/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface SchemaActorNameShow {
  /**
   * ID
   * @example "0"
   */
  id: string
  /** 演員名字 */
  name: string
}

export interface SchemaActorNameShowQueryResult {
  data: SchemaActorNameShow[]
  page_result: SchemaPaginationResult
  /** @example "0" */
  tag_version: string
}

export interface SchemaActorShow {
  /** 後台状态(1:启用 2:停用) */
  backend_status: number
  /** 封面路徑 */
  cover_path: string
  /** 建立时间 */
  created_at: string
  /** 罩杯 */
  cup: string
  /** 演員介紹 */
  description: string
  /** 性別 1-boy 2-girl */
  gender: number
  /** 圖片路徑 */
  icon_path: string
  /**
   * ID
   * @example "0"
   */
  id: string
  /** 演員名字 */
  name: string
  /** 演員名字(原) */
  orig_name: string
  /** 推薦(1:是 2:否) */
  recommend: number
  /** 排序(推薦) */
  recommend_seqno: number
  /**
   * 區域ID
   * @example "0"
   */
  region_id: string
  /** 排序 */
  seqno: number
  /** 來源 */
  source: string
  /** 前端状态(1:启用 2:停用) */
  status: number
  /** 更新時間 */
  updated_at: string
  /** 影片數量 */
  video_num: number
  /** 未上架影片數量 */
  video_off_shelf_num: number
  /** 上架影片數量 */
  video_on_shelf_num: number
}

export interface SchemaActorShowQueryResult {
  data: SchemaActorShow[]
  page_result: SchemaPaginationResult
  /** @example "0" */
  tag_version: string
}

export interface SchemaAnnounceShow {
  /** 按鈕A名稱 */
  button_a: string
  /** 按鈕B名稱 */
  button_b: string
  /** 內容(base64) */
  content: string
  /** 建立時間 */
  created_at: string
  /** device type(ios,android,cookie) */
  device_type: string
  /** 結束時間 */
  end_at: string
  /**
   * ID
   * @example "0"
   */
  id: string
  /** 連結A */
  link_a: string
  /** 連結B */
  link_b: string
  /** 操作人 */
  operator: string
  /** 排序 */
  seqno: number
  /** 開始時間 */
  start_at: string
  /** 状态(1:启用 2:停用) */
  status: number
  /** 標題 */
  title: string
  /** 類型(1:代理公告 2:會員公告) */
  type: number
  /** 更新時間 */
  updated_at: string
}

export interface SchemaAnnounceShowQueryResult {
  data: SchemaAnnounceShow[]
  page_result: SchemaPaginationResult
}

export interface SchemaBindPromoteCodeParam {
  /** 推薦碼 */
  promote_code: string
}

export interface SchemaChapterViewParam {
  /**
   * chapter id
   * @example "0"
   */
  chapter_id?: string
}

export interface SchemaCheckApi {
  /** input string */
  input: string
}

export interface SchemaCmsEventCreateParam {
  data?: SchemaCmsEventItem[]
}

export interface SchemaCmsEventItem {
  /** 次數: 統計為去重 固定填1就可以 */
  count?: number
  /** nav id */
  nav_id?: number
  /** nav 名稱: 冗余數據 前端傳送 減少db查詢 */
  nav_name?: string
  /** tab id */
  tab_id?: number
  /** tab 名稱: 冗余數據 前端傳送 減少db查詢 */
  tab_name?: string
}

export interface SchemaCmsIconuiShow {
  /** 1：直屏 2：橫屏，可作為進入遊戲預設直 / 橫屏使用 */
  direction: number
  /** 內部游戏跳轉(wali,jdb,pg) */
  game_platform: string
  /** 游戏Type id(1:捕魚;2:視訊;3:棋牌;4:電子;5:體育;6:彩票) */
  game_type_id: number
  /** 圖片路徑 */
  icon_path: string
  /**
   * ID
   * @example "0"
   */
  id: string
  /** 內部跳轉ID */
  internal_id: string
  /** 類型(1:內部 2:外部) */
  jump_method: number
  /** 跳轉類型(1:片商 2:演員, 3:片商列表, 4:演員列表, 5:開通VIP, 6:鏈接, 7: NAV, 8:遊戲) */
  jump_type: number
  /** 名稱 */
  name: string
  /** 外部跳轉鏈接 */
  outside_url: string
  /** 排序 */
  seqno: number
  /** 状态(1:启用 2:停用) */
  status: number
  /**
   * Tab ID
   * @example "0"
   */
  tab_id: string
  /** Tab IDs */
  tab_ids: string[]
  /**
   * 演員 ID
   * @example "0"
   */
  video_actor_id: string
  /**
   * 片商 ID
   * @example "0"
   */
  video_producer_id: string
}

export interface SchemaCmsPublishResult {
  /** 對齊(靠左1 置中2 靠右3) */
  align: number
  /** 建立時間 */
  created_at: string
  /** 是否隱藏頭部(1:隱藏 2:不隱藏) */
  hide_head: number
  /**
   * 圖標ID
   * @example "0"
   */
  icon_id: string
  /** 圖片路徑 */
  icon_path: string
  /** 圖片路徑2 */
  icon_path2: string
  /**
   * ID
   * @example "0"
   */
  id: string
  /** Nav名稱 */
  name: string
  /** 搜索類型(1:長視頻 2:短視頻 3.Comic 4:小說) */
  search_types: number[]
  /** 排序 */
  seqno: number
  /**
   * 平台ID
   * @example "0"
   */
  site_id: string
  /** 状态(1:启用 2:停用) */
  status: number
  /** tabs */
  tabs: SchemaCmsTabDetail[]
  /** 類型(1:一般,2:遊戲,3:發現,4:我的,5:應用,6:瀑布流) */
  type: number
  /** 域名 */
  url: string
}

export interface SchemaCmsSectionShow {
  /** 建立時間 */
  created_at: string
  /** 數量 */
  displayno: number
  /** header/footer(HF類別 1:無 2:置頂 3:置底) */
  hf_type: number
  /** 自訂熱門天數結束 (搭配 days_hot, 1-30) */
  hot_days: number
  /** 自訂熱門天數起始 (搭配 days_hot, 0=今天) */
  hot_days_start: number
  /** 自訂熱門月份 (搭配 month_hot 排序使用, YYYY-MM，多月份以逗號分隔最多12個，跨月瀏覽數會加總) */
  hot_month: string
  /** 自訂熱門年份 (搭配 year_hot 排序使用, YYYY) */
  hot_year: string
  /**
   * ID
   * @example "0"
   */
  id: string
  /** 顯示"更多"(1:启用 2:停用) */
  more_isvisible: number
  /** 顯示"下一批"(1:启用 2:停用) */
  next_isvisible: number
  /** 排序 */
  seqno: number
  /** 连载状态(0.未指定 1.連載 2.完結) */
  serial: number
  /** 顯示"查看更多"(1:启用 2:停用) */
  show_more_isvisible: number
  /** 状态(1:启用 2:停用) */
  status: number
  /**
   * Tab ID
   * @example "0"
   */
  tab_id: string
  /**
   * 模板 ID (長視頻模板ID:( "1":小圖(默認) ,"2":大圖 ,"3":一大多小 ,"4":中圖左右滑動,"5":多小左右滑動,"8":一行二豎,"9":一行三豎,"10":豎封面左右滑動,"11":橫版兩行兩個半向左滑動,"12":橫版一大兩半左右滑動循環,"13":橫版一大兩小半向左滑動,"14":豎版三個單行左滑,"15":豎版一大兩半左右滑動循環,"16":豎版一大左右滑動循環,"17":豎版兩個半向左滑動,"18":豎版三個半向左滑動) <br>  短視頻模板ID:( "101":一行兩個(默認) ,"102":一行三個 ,"103":單行左滑(兩個半) ,"104":左右滑動,"105":豎版一大左右滑動循環,"106":豎版兩個半向左滑動,"107":豎版三個半向左滑動) <br> 漫畫模板ID:( "201":一行二豎(默認) ,"202":一行三豎 ,"203":單行左滑 ,"204":左右滑動) <br> 小說模板ID:("301":一行二豎(默認) ,"302":一行三豎 ,"303":單行左滑 ,"304":左右滑動))
   * @example "0"
   */
  template_id: string
  /** 標題 */
  title: string
  /** 顯示標題(1:启用 2:停用) */
  title_is_visible: number
  /** 置頂(HF)排序 */
  top_seqno: number
  /** 影片類別(1:長視頻 2:短視頻 3.Comic) */
  type: number
  /** 演員 */
  video_actor: string[]
  /** 分類 */
  video_category: string[]
  /** 上傳時間範圍開始 (ex. 2024-01-01) */
  video_created_date_begin: string
  /** 上傳時間範圍結束 (ex. 2024-01-02) */
  video_created_date_end: string
  /** 付費類型(0: 不限 1:免費 2:金幣 3:VIP) */
  video_payment_type: number
  /**
   * 片商 ID
   * @example "0"
   */
  video_producer_id: string
  /** 片商 ID (多選) */
  video_producer_ids: string[]
  /**
   * 地區 ID
   * @example "0"
   */
  video_region_id: string
  /** 區域多選 */
  video_region_ids: string[]
  /** 排序規則 ("view_count", "created_at", "video_code", "-video_code", "updated_at", "on_shelf_at", "off_shelf_at", "random", "vip_first", "7_days_hot", "14_days_hot", "30_days_hot", "days_hot", "month_hot") */
  video_sortby: string
  /** 標籤 */
  video_tag: string[]
  /** 話題 */
  video_topic: string[]
  /**
   * up主 ID
   * @example "0"
   */
  video_uploader_id: string
  /** 顯示"開通VIP"(1:启用 2:停用) */
  vip_isvisible: number
}

export interface SchemaCmsTabDetail {
  /** 建立時間 */
  created_at: string
  /** 基礎模式 第一期只支援一種模式 */
  desplay_type: number
  /**
   * 金剛區模板
   * @example "0"
   */
  iconui_template: string
  /** tabs */
  iconuis: SchemaCmsIconuiShow[]
  /**
   * ID
   * @example "0"
   */
  id: string
  /** 隨機(1:启用 2:停用) */
  is_random: number
  /** Tab名稱 */
  name: string
  /**
   * Nav ID
   * @example "0"
   */
  nav_id: string
  /** tabs */
  sections: SchemaCmsSectionShow[]
  /** 排序 */
  seqno: number
  /** 顯示輪播 */
  show_ad: number
  /** 顯示金剛區 */
  show_iconui: number
  /** 状态(1:启用 2:停用) */
  status: number
}

export interface SchemaComicChapterShow {
  /** 是否用金幣買過此話(1:是 2:否) */
  buy_chapter: number
  /** 話數 */
  chapter_seq: number
  /**
   * Comic ID
   * @example "0"
   */
  comic_id: string
  /** Comic Title */
  comic_title: string
  /** 每話封面URL */
  cover_url: string
  /**
   * 唯一標識
   * @example "0"
   */
  id: string
  /** 是否固定免費(1:是 2:否) */
  is_fix_free: number
  /** 是否同步到阿里 */
  is_sync_oss: number
  /** 下架時間 */
  off_shelf_at: string
  /** 上架時間 */
  on_shelf_at: string
  /** 每頁路徑 */
  page_url: string[]
  /** 每話名稱 ex:第X話 */
  prefix_name: string
  /** 每話商品金幣 */
  product_chapter_coin: number
  /** 每話商品Id */
  product_chapter_id: string
  /** 每話商品名稱 */
  product_chapter_name: string
  /** 上架状态(1:未上架 2:上架 3:下架) */
  state: number
  /** 同步到阿里時間 */
  sync_oss_at: string
  /** 每話標題 */
  title: string
  /** 上傳時間 */
  uploaded_at: string
}

export interface SchemaComicChapterShowQueryResult {
  data: SchemaComicChapterShow[]
  page_result: SchemaPaginationResult
}

export interface SchemaComicKeyResult {
  /** aes key */
  key: string
}

export interface SchemaComicShow {
  /** 是否購買全本 1:是 2:否 */
  buy_all: number
  /** 分類 Id(舊版相容) */
  category_id: string
  /** 分類 Ids */
  category_ids: string[]
  /** 分類名稱(舊版相容) */
  category_name: string
  /** 多個分類名稱 */
  category_names: string[]
  /** 總話數 */
  chapter_count: number
  /** Chapter最後上傳時間(後台用) */
  chapter_last_uploaded_at: string
  /** 漫畫編號 */
  comic_code: string
  /** 封面URL */
  cover_url: string
  /** 建立時間 */
  created_at: string
  /** 是否收藏 1:是 2:否 */
  favorite: number
  /** 收藏數 */
  favorite_count: number
  /** 免費章節 Chapter Seqs(1,2,3,4,5)(後台用) */
  fix_free_chapter_seqs: string[]
  /**
   * ID
   * @example "0"
   */
  id: string
  /**
   * 最後瀏覽的話id(傳入ID才顯示)
   * @example "0"
   */
  last_read_chapter_id: string
  /** 最新一話名稱 */
  latest_chapter_prefix_name: string
  /** 下架時間 */
  off_shelf_at: string
  /** 1:整本 2:非整本 */
  offprint: number
  /** 上架時間 */
  on_shelf_at: string
  /** 1:Free 2:Coin 3:Vip */
  payment_type: number
  /** all comic 商品金幣 */
  product_all_coin: number
  /**
   * all comic 商品ID
   * @example "0"
   */
  product_all_id: string
  /** all comic商品名稱 */
  product_all_name: string
  /** one chapter商品名稱 */
  product_chapter_coin: number
  /**
   * one chapter商品ID
   * @example "0"
   */
  product_chapter_id: string
  /** one chapter商品名稱 */
  'product_chapter_name;': string
  /**
   * 地區(1:日漫 2:韓漫)
   * @example "0"
   */
  region: string
  /** 1.連載 2.完結 */
  serial: number
  /** 來源站 */
  source: string
  /** 來源站名稱 */
  source_name: string
  /** 上架状态(1:未上架 2:上架 3:下架) */
  state: number
  /** 状态(1:启用 2:停用) */
  status: number
  /** 簡介(傳入ID才顯示) */
  summary: string
  /** Tag Ids */
  tag_ids: string[]
  /** Tag Names(from redis) */
  tag_names: string[]
  /** 標題 */
  title: string
  /** 未上架Chapter數量(後台用) */
  un_shelf_chapter_count: number
  /** 更新時間 */
  updated_at: string
  /** 觀看數 */
  view_count: number
}

export interface SchemaComicShowQueryResult {
  data: SchemaComicShow[]
  page_result: SchemaPaginationResult
}

export interface SchemaCooperationShow {
  /** 帳號 */
  account: string
  /** 建立時間 */
  created_at: string
  /** 描述 */
  desc: string
  /**
   * ID
   * @example "0"
   */
  id: string
  /** 連結 */
  link: string
  /** 連結類型(1:TG 2:QQ) */
  link_type: number
  /** 名稱 */
  name: string
  /** 排序 */
  seqno: number
  /**
   * 位置(1:落地頁 2:APP)
   * @example "0"
   */
  site_id: string
  /** 状态(1:启用 2:停用) */
  status: number
}

export interface SchemaCooperationShowQueryResult {
  data: SchemaCooperationShow[]
  page_result: SchemaPaginationResult
}

export interface SchemaDomainShow {
  /** 後台抓key host Domain(前台不需要) */
  domain_adminKey: string[]
  /** 漫畫封面+內容 domain */
  domain_comic: string[]
  /** MPS 備份桶 domain */
  domain_mps_backup: string[]
  /** 小說封面+內容 domain */
  domain_novel: string[]
  /** Original Domain 完整影片host網址 */
  domain_original: string[]
  /** picuture : product + iconui + nav icon */
  domain_picture: string[]
  /** Preview  Domain 預覽影片 + 封面host網址 + 頭像網址 + uploader頭像 */
  domain_preview: string[]
  /** Original Domain 完整影片網址名稱 */
  name_original: string[]
}

export interface SchemaErrHistory {
  /** 剪貼簿 */
  clipboard: string
  /** 建立時間 */
  created_at: string
  /** DeviceID */
  device_id: string
  /** DeviceType(ios android) */
  device_type: string
  /** 錯誤訊息 */
  err_msg: string
  /**
   * ID
   * @example "0"
   */
  id: string
}

export interface SchemaErrHistoryCreateParam {
  /** 剪貼簿 */
  clipboard?: string
  /** DeviceID */
  device_id?: string
  /** DeviceType(ios android) */
  device_type?: string
  /** 錯誤訊息 */
  err_msg?: string
}

export interface SchemaErrorItem {
  code?: number
  message?: string
}

export interface SchemaErrorResult {
  error?: SchemaErrorItem
}

export interface SchemaExchangeTempTokenParam {
  /** 臨時訪問令牌 */
  temp_access_token: string
}

export interface SchemaIDResult {
  /** @example "0" */
  id: string
}

export interface SchemaKefuWorkOrder {
  /**
   * 代理ID
   * @example "0"
   */
  agent_id: string
  /** 代理模式(1:CPA 2:CPS, 3:CPC) */
  agent_mode: number
  /** 代理名稱 */
  agent_name: string
  /** 代理帳號    // 代理帳號 */
  agent_user_name: string
  /** 版本號 */
  app_version: string
  /** CPA 激活返傭 */
  cpa_rebate_price: number
  /** CPC 萬IP價格 */
  cpc_price: number
  /** CPS 返傭比例 */
  cps_rebate_rate: number
  /** 建立時間 */
  created_at: string
  /** 描述 */
  desc: string
  /** 廠牌機型 */
  device_model: string
  /** 作業系統 */
  device_os: string
  /** 硬體類型(ios: IDFA, android: GPS ADID，h5: cookie) */
  device_type: string
  /**
   * ID
   * @example "0"
   */
  id: string
  /**
   * 會員ID
   * @example "0"
   */
  member_id: string
  /** 會員名稱 */
  member_name: string
  /** 會員顯示ID */
  member_show_id: string
  /** 會員帳號 (空值為遊客) */
  member_user_name: string
  /** VIP(1:Yes 2:No 3:forever) */
  member_vip: number
  /** 問題類型(1: Video 2: Recharge 3:oaid) */
  problem_type: number
}

export interface SchemaKefuWorkOrderCreateParam {
  /** 版本號 */
  app_version?: string
  /** 描述 */
  desc?: string
  /** 廠牌機型 */
  device_model?: string
  /** 作業系統 */
  device_os?: string
  /** 硬體類型(ios: IDFA, android: GPS ADID，h5: cookie) */
  device_type?: string
  /** 問題類型(1: Video 2: Recharge) */
  problem_type?: number
}

export interface SchemaLoginTokenInfo {
  /** 訪問令牌 */
  access_token: string
  /** 是否已綁定２ＦＡ 1:Y 2:N */
  bind_2fa: number
  /** 過期時間戳 */
  expires_at: number
  /** 邀請碼 */
  invite_code: string
  /** 強制更換密碼(1:是 2:否) */
  is_force_update_pwd: number
  /** 是否超級管理員(1:Y 2:N) */
  is_super_admin: number
  /** 2fa qrcode */
  qrcode: string
  /** 重設密碼時間 */
  reset_password_at: string
  /** 角色(10:管理員 50:標籤人員) */
  role: number
  /** 令牌類型 */
  token_type: string
  /** 提示是否需更換密碼(1:是 2:否) */
  warn_update_pwd: number
}

export interface SchemaMemberAnnounceShow {
  /** 建立時間 */
  created_at: string
  /** 說明 */
  description: string
  /** device type(ios,android,cookie) */
  device_type: string
  /**
   * ID
   * @example "0"
   */
  id: string
  /** 名稱 */
  name: string
  /** 操作人 */
  operator: string
  /** 状态(1:启用 2:停用) */
  status: number
  /** 更新時間 */
  updated_at: string
}

export interface SchemaMemberAnnounceShowQueryResult {
  data: SchemaMemberAnnounceShow[]
  page_result: SchemaPaginationResult
}

export interface SchemaMemberBindDevParam {
  /** code */
  code: string
}

export interface SchemaMemberBindResult {
  /** code */
  code: string
}

export interface SchemaMemberBuyVideoParam {
  /**
   * Video Id
   * @example "0"
   */
  video_id?: string
}

export interface SchemaMemberComicFavoriteRelCreateParam {
  /**
   * Comic ID
   * @example "0"
   */
  comic_id?: string
}

export interface SchemaMemberDeviceParam {
  /** 打包日期的加密字串 */
  apkenc?: string
  /** App ID */
  app_id?: string
  /** 硬體ID */
  device_id: string
  /** 硬體類型(ios: ios, android: android，h5: cookie) */
  device_type: string
  /** 邀請碼 */
  invite_code?: string
  /** First Install(1:yes 2:no) */
  is_first?: number
  /** os version */
  os_version?: string
  /** Phone Device */
  phone_device?: string
  /** 推薦碼 */
  promote_code?: string
  /** 版本號 */
  version?: string
}

export interface SchemaMemberEditParam {
  /** 會員暱稱 */
  name: string
}

export interface SchemaMemberFavoriteRelCreateParam {
  /**
   * ID     uint64 `json:"id,string"` // ID
   * @example "0"
   */
  member_id?: string
  /**
   * Video Id
   * @example "0"
   */
  video_id?: string
}

export interface SchemaMemberGameCreateUrlParam {
  /** 遊戲频道ID */
  channel_id?: string
  /** 成員ID */
  member_id?: number
  /** 成員名稱 */
  member_name?: string
}

export interface SchemaMemberLandingParam {
  /** 邀請碼 */
  invite_code?: string
}

export interface SchemaMemberLikeRelCreateParam {
  /**
   * ID     uint64 `json:"id,string"` // ID
   * @example "0"
   */
  member_id?: string
  /**
   * Video Id
   * @example "0"
   */
  video_id?: string
}

export interface SchemaMemberLoginParam {
  /** 密码 */
  password: string
  /** 帐号 */
  user_name: string
}

export interface SchemaMemberNovelFavoriteRelCreateParam {
  /**
   * Novel ID
   * @example "0"
   */
  novel_id?: string
}

export interface SchemaMemberOrderCreateParam {
  /**
   * 支付渠道ID
   * @example "0"
   */
  pay_channel_id?: string
  /**
   * 支付類型ID
   * @example "0"
   */
  pay_type_id?: string
  /**
   * 商品ID
   * @example "0"
   */
  product_id?: string
  /** 完成訂單跳轉地址 */
  return_url?: string
}

export interface SchemaMemberOrderResult {
  /** @example "0" */
  id: string
  /** pay url(下單頁面) */
  pay_url: string
  /** 支援的scheme ["weixin", "alipays", "https"] */
  scheme: string[]
}

export interface SchemaMemberPhoneCodeParam {
  /** 手机号 */
  phone: string
}

export interface SchemaMemberPhoneCodeResult {
  /** 再次申请时间(s) */
  cool_down: number
  /** 有效时间(s) */
  count_down: number
}

export interface SchemaMemberPromoteRelShow {
  /** 建立時間 */
  created_at: string
  /** ID */
  id: number
  /** Member Id */
  member_id: number
  /** 被推薦人 Id */
  promote_id: number
  /** 被推薦人 show Id */
  promote_show_id: string
}

export interface SchemaMemberPromoteRelShowQueryResult {
  data: SchemaMemberPromoteRelShow[]
  page_result: SchemaPaginationResult
}

export interface SchemaMemberRegisterParam {
  /** 密码 */
  password: string
  /** 帐号 */
  user_name: string
}

export interface SchemaMemberShow {
  /** 帳號綁定時間 */
  account_at: string
  /** 代理帳號 */
  agent_account: string
  /** 激活返傭 */
  agent_cpa_rebate_price: number
  /** 返傭比例 */
  agent_cps_rebate_rate: number
  /**
   * 代理ID
   * @example "0"
   */
  agent_id: string
  /** 代理階級路徑 */
  agent_id_path: string
  /** 代理模式(1:CPA 2:CPS) */
  agent_mode: number
  /** App ID */
  app_id: string
  /** 餘額 */
  coin: number
  /** 金幣觀看期效 */
  coin_watch_at: string
  /** 建立時間 */
  created_at: string
  /** 設備綁定時間 */
  device_at: string
  /** 硬體ID */
  device_id: string
  /** 硬體類型(ios: ios, android: android，h5: cookie) */
  device_type: string
  /** 邮箱 */
  email: string
  /** 遊戲儲值(1:已儲值 2:未儲值) */
  game_deposit: number
  /** 遊戲登入(1:已登入 2:未登入) -> 遊戲下注(1:已下注 2:未下注) */
  game_login: number
  /**
   * ID
   * @example "0"
   */
  id: string
  /** 是否可以手動輸入推薦碼 */
  is_manual_promote: boolean
  /** `IsVIP(1:Yes 2:No) */
  is_vip: number
  /** 最後登入地區 */
  lastlogin_area: string
  /** 最後登入時間 */
  lastlogin_at: string
  /** 最後登入IP */
  lastlogin_ip: string
  /** 最後登入版本號 */
  lastlogin_version: string
  /** 會員暱稱 */
  name: string
  /** os version */
  os_version: string
  /** 手机号 */
  phone: string
  /** Phone Device */
  phone_device: string
  /** 推薦碼 */
  promote_code: string
  /** 推薦人 show ID */
  promote_show_id: string
  /** 註冊地區 */
  register_area: string
  /** 註冊時間 */
  register_at: string
  /** 註冊IP */
  register_ip: string
  /** 註冊版本號 */
  register_version: string
  /** 會員顯示ID */
  show_id: string
  /** 状态(1:启用 2:停用) */
  status: number
  /** 總買金幣數 */
  total_buy_coin: number
  /** 點播紀錄(總花金幣數) */
  total_buy_video_coin: number
  /** 點播紀錄(總花金幣次數) */
  total_buy_video_count: number
  /** 付費紀錄(金幣) */
  total_recharge_coin: number
  /** 付費紀錄(VIP) */
  total_recharge_vip: number
  /** 會員類型(1:遊客 2:會員) */
  type: number
  /** user agent header */
  user_agent: string
  /** 會員帳號 */
  user_name: string
  /** VIP(1:Yes 2:No 3:Forever) */
  vip: number
  /** VIP期效 */
  vip_at: string
  /** VIP name(購買的最後一個VIP商品名稱) */
  vip_name: string
  /** 觀影次數 */
  watch_video_count: number
}

export interface SchemaNovelChapterShow {
  /** 是否用金幣買過此話(1:是 2:否) */
  buy_chapter: number
  /** 話數 */
  chapter_seq: number
  /** 每話封面URL */
  cover_url: string
  /**
   * 唯一標識
   * @example "0"
   */
  id: string
  /** 是否固定免費(1:是 2:否) */
  is_fix_free: number
  /** 是否同步到阿里 */
  is_sync_oss: number
  /**
   * Novel ID
   * @example "0"
   */
  novel_id: string
  /** Novel Title */
  novel_title: string
  /** 下架時間 */
  off_shelf_at: string
  /** 上架時間 */
  on_shelf_at: string
  /** 每頁路徑 */
  page_url: string[]
  /** 每話名稱 ex:第X話 */
  prefix_name: string
  /** 每話商品金幣 */
  product_chapter_coin: number
  /** 每話商品Id */
  product_chapter_id: string
  /** 每話商品名稱 */
  product_chapter_name: string
  /** 上架状态(1:未上架 2:上架 3:下架) */
  state: number
  /** 同步到阿里時間 */
  sync_oss_at: string
  /** 每話標題 */
  title: string
  /** 上傳時間 */
  uploaded_at: string
}

export interface SchemaNovelChapterShowQueryResult {
  data: SchemaNovelChapterShow[]
  page_result: SchemaPaginationResult
}

export interface SchemaNovelKeyResult {
  /** aes key */
  key: string
}

export interface SchemaNovelShow {
  /** 作者 */
  author: string
  /** 是否購買全本 1:是 2:否 */
  buy_all: number
  /** 分類 Id */
  category_id: string
  /** 分類 Ids */
  category_ids: string[]
  /** 分類名稱 */
  category_name: string
  /** 多個分類名稱 */
  category_names: string[]
  /** 總話數 */
  chapter_count: number
  /** Chapter最後上傳時間 */
  chapter_last_uploaded_at: string
  /** 封面URL */
  cover_url: string
  /** 建立時間 */
  created_at: string
  /** 是否收藏 1:是 2:否 */
  favorite: number
  /** 收藏數 */
  favorite_count: number
  /** 免費章節 Chapter Seqs(1,2,3,4,5) */
  fix_free_chapter_seqs: string[]
  /**
   * ID
   * @example "0"
   */
  id: string
  /**
   * 最後瀏覽的話id(傳入ID才顯示)
   * @example "0"
   */
  last_read_chapter_id: string
  /** 小說編號 */
  novel_code: string
  /** 下架時間 */
  off_shelf_at: string
  /** 1:整本 2:非整本 */
  offprint: number
  /** 上架時間 */
  on_shelf_at: string
  /** 1:Free 2:Coin 3:Vip */
  payment_type: number
  /** all Novel 商品金幣 */
  product_all_coin: number
  /**
   * all Novel 商品ID
   * @example "0"
   */
  product_all_id: string
  /** all Novel商品名稱 */
  product_all_name: string
  /** one chapter商品名稱 */
  product_chapter_coin: number
  /**
   * one chapter商品ID
   * @example "0"
   */
  product_chapter_id: string
  /** one chapter商品名稱 */
  'product_chapter_name;': string
  /**
   * 地區 Id
   * @example "0"
   */
  region_id: string
  /** 地區名稱 */
  region_name: string
  /** 1.連載 2.完結 */
  serial: number
  /** 來源站 */
  source: string
  /** 來源站名稱 */
  source_name: string
  /** 上架状态(1:未上架 2:上架 3:下架) */
  state: number
  /** 状态(1:启用 2:停用) */
  status: number
  /** 簡介(傳入ID才顯示) */
  summary: string
  /** Tag Ids */
  tag_ids: string[]
  /** Tag Names(from redis) */
  tag_names: string[]
  /** 標題 */
  title: string
  /** 未上架Chapter數量 */
  un_shelf_chapter_count: number
  /** 更新時間 */
  updated_at: string
  /** 觀看數 */
  view_count: number
}

export interface SchemaNovelShowQueryResult {
  data: SchemaNovelShow[]
  page_result: SchemaPaginationResult
}

export interface SchemaOholoEventCreateParam {
  data?: SchemaOholoEventItem[]
}

export interface SchemaOholoEventCreateResp {
  count: number
}

export interface SchemaOholoEventItem {
  /** 點擊次數 */
  count?: number
  /** 日期: 2023-08-22 */
  date?: string
  /** material id: 金剛區固定傳10000 */
  material_id?: number
  /** material 名稱: 改成服務端處理 app傳空字串即可 */
  material_name?: string
  /** 廣告版位id: 金剛區固定傳10000 */
  oholo_site_id?: number
  /** 廣告版位名稱: 冗余數據 前端傳送 減少db查詢, 金剛區版位傳金剛區 */
  oholo_site_name?: string
  /** oholoer id */
  oholoer_id?: number
  /** oholoer link (金主連結) */
  oholoer_link?: string
  /** oholoer name (金主名稱) */
  oholoer_name?: string
}

export interface SchemaOholoLog {
  /**
   * 代理ID
   * @example "0"
   */
  agent_id: string
  /**
   * 代理名稱
   * @example ""
   */
  agent_name: string
  /** ID */
  id: number
  /**
   * 素材ID
   * @example "0"
   */
  material_id: string
  /**
   * 會員ID
   * @example "0"
   */
  member_id: string
  /**
   * 會員顯示ID
   * @example ""
   */
  member_show_id: string
  /**
   * 廣告主ID
   * @example "0"
   */
  oholoer_id: string
  /**
   * 廣告主名稱
   * @example ""
   */
  oholoer_name: string
  /**
   * 版位名稱
   * @example ""
   */
  site_name: string
}

export interface SchemaOholoLogCreateParam {
  /** 素材ID */
  material_id?: number
}

export interface SchemaOholoMaterialShow {
  /** android id */
  android_id: string
  /** 是否自動關閉 (1:是 2:否) */
  auto_close: number
  /** 輪播時間 */
  carousel_time: number
  /** 倒計時時長 */
  countdown: number
  /** 建立時間 */
  created_at: string
  /** 1：直屏 2：橫屏，可作為進入遊戲預設直 / 橫屏使用 */
  direction: number
  /** 結束時間 */
  end_at: string
  /** 過期狀態(1:未到期 2:到期) */
  expire_status: number
  /** 過濾條件 */
  filter_section_ids: string[]
  /** 游戏平台(wali,jdb) */
  game_platform: string
  /** 游戏type id(1:捕魚;2:視訊;3:棋牌;4:電子;5:體育;6:彩票) */
  game_type_id: number
  /** 圖片路徑 */
  icon_path: string
  /**
   * ID
   * @example "0"
   */
  id: string
  /** 內部跳轉ID */
  internal_id: string
  /** 內部跳轉類型 (1: NAV ID(default) 2:遊戲ID 3:片商ID 4:演員ID, 5:片商列表, 6:演員列表, 7:開通VIP)) */
  internal_type: number
  /** ios id */
  ios_id: string
  /** 是否所有頻道(1:自動全選 2:人工設定) ps: only for 16.金剛區廣告 */
  is_all_tab: number
  /** 素材連結 */
  link: string
  /** 素材Type (1:內部 2:外部) */
  link_type: number
  /** 素材名稱 */
  name: string
  /** 金主結束時間 */
  oholoer_end_at: string
  /**
   * 金主
   * @example "0"
   */
  oholoer_id: string
  /** 金主連結 */
  oholoer_link: string
  /** 金主名稱 */
  oholoer_name: string
  /** 金主開始時間 */
  oholoer_start_at: string
  /** 金主狀態 */
  oholoer_status: number
  /** 撥放時間 */
  play_time: number
  /** 機率(0~100) */
  pr: number
  /** 排序 */
  seqno: number
  /**
   * 版位ID(對前端沒用)
   * @deprecated
   * @example "0"
   */
  site_id: string
  /** 版位類型(1. 启动页 2. 频道轮播 3. 橱窗下方 4. 橱窗更多 5. 橱窗中 6. 播放页面 7. 个人中心 8. 公告弹窗 9. 应用轮播 10. 应用图标5 11. 发现 12. 应用图标2 13. 应用图标3  14. 短视频广告位  15. 动态频道广告位 16.金剛區廣告) */
  site_type: number
  /** 開始時間 */
  start_at: string
  /** 状态(1:启用 2:停用) */
  status: number
  /** 所屬頻道 IDs ps: only for 16.金剛區廣告 */
  tab_ids: string[]
}

export interface SchemaOholoMaterialShowQueryResult {
  data: SchemaOholoMaterialShow[]
  page_result: SchemaPaginationResult
}

export interface SchemaPaginationResult {
  base_offset: number
  current: number
  pageSize: number
  total: number
}

export interface SchemaProducerNameShow {
  /**
   * ID
   * @example "0"
   */
  id: string
  /** 片商名稱 */
  name: string
}

export interface SchemaProducerNameShowQueryResult {
  data: SchemaProducerNameShow[]
  page_result: SchemaPaginationResult
  /** @example "0" */
  tag_version: string
}

export interface SchemaProducerShow {
  /** 片商帳號 */
  account: string
  /** 建立时间 */
  created_at: string
  /** 圖片路徑 */
  icon_path: string
  /**
   * ID
   * @example "0"
   */
  id: string
  /** 片商名稱 */
  name: string
  /** 片商類型(1:無 2:國產傳媒 3:AV廠商 4:UP原創 5:剪輯達人) */
  producer_type: number
  /** Avatar    []byte     `json:"avatar"`     // 頭像(類型是字串base64) */
  recommend: number
  /** 排序(推薦) */
  recommend_seqno: number
  /** 排序 */
  seqno: number
  /** Sid */
  sid: number
  /** 状态(1:启用 2:停用) */
  status: number
  /** 更新時間 */
  updated_at: string
  /** 影片數量 */
  video_num: number
}

export interface SchemaProducerShowQueryResult {
  data: SchemaProducerShow[]
  page_result: SchemaPaginationResult
  /** @example "0" */
  tag_version: string
}

export interface SchemaProductShow {
  /** 金幣數量 */
  coin: number
  /** 建立時間 */
  created_at: string
  /** 描述 */
  describe: string
  /** 圖片路徑 */
  icon_path: string
  /**
   * ID
   * @example "0"
   */
  id: string
  /** 商品名稱 */
  name: string
  /** 原價格 */
  origin_price: number
  /** 價格 */
  price: number
  /** 商品類型(1:金幣 2:VIP) */
  product_type: number
  /** 是否返傭(1:是 2:否) */
  rebate: number
  /** 排序 */
  seqno: number
  /** 状态(1:启用 2:停用) */
  status: number
  /**
   * 副商品ID
   * @example "0"
   */
  subproduct_id: string
  /** VIP天數 */
  vip_days: number
  /** VIP永久(1:是 2:否) */
  vip_forever: number
}

export interface SchemaProductShowQueryResult {
  data: SchemaProductShow[]
  page_result: SchemaPaginationResult
}

export interface SchemaProductVideoShow {
  /** 金幣 */
  coin: number
  /** 建立時間 */
  created_at: string
  /**
   * ID
   * @example "0"
   */
  id: string
  /** 商品名稱 */
  name: string
  /** 排序 */
  seqno: number
  /** 状态(1:启用 2:停用) */
  status: number
}

export interface SchemaProductVideoShowQueryResult {
  data: SchemaProductVideoShow[]
  page_result: SchemaPaginationResult
}

export interface SchemaPromoteDomainShow {
  /** CPC(1:Cpc域名, 2:not Cpc域名) */
  cpc: number
  /** 建立時間 */
  created_at: string
  /** 域名名稱 */
  domain_name: string
  /**
   * ID
   * @example "0"
   */
  id: string
  /** 推薦 */
  recommend: number
  /** 状态(1:启用 2:停用) */
  status: number
  /** 域名標題 */
  title: string
  /** 類別(1:常用, 2:QQ, 3:微信) */
  type: number
}

export interface SchemaPromoteDomainShowQueryResult {
  data: SchemaPromoteDomainShow[]
  page_result: SchemaPaginationResult
}

export interface SchemaPromoteUrlCodeResult {
  /** url */
  url: string
}

export interface SchemaShortVideoShow {
  /**
   * 演員地區ID
   * @example "0"
   */
  actor_region_id: string
  /** 是否用金幣買過影片 */
  buy_video: number
  /** 分類 Ids */
  category_ids: string[]
  /** 封面 (橫向) */
  coverphoto_h: string
  /** 封面 (縱向) */
  coverphoto_v: string
  /** 建立時間 */
  created_at: string
  /**
   * 執行人員
   * @example "0"
   */
  creator_id: string
  /** 執行人員名稱 */
  creator_user_name: string
  /** 描述 */
  description: string
  /** enc url */
  enc_url: string
  /** 收藏 (1:是 2:否) (僅在detail api計算) */
  favorite: number
  /** 收藏數 */
  favorite_count: number
  /** h265影片key */
  h265_key: string
  /** h265影片地址(高清) */
  h265_url: string
  /** 影片地址(高清) */
  highres_url: string
  /**
   * ID
   * @example "0"
   */
  id: string
  /** 是否同步到阿里(1:success 2:no sync 3:failed 4:going) */
  is_sync_oss: number
  /** 喜歡 (1:是 2:否) (僅在detail api計算) */
  like: number
  /** 點讚數 */
  like_count: number
  /** 下架時間 */
  off_shelf_at: string
  /** 上架時間 */
  on_shelf_at: string
  /** 原片番號 */
  ong_video: string
  /** 1:免費 2:金幣 3:VIP */
  payment_type: number
  /** prview key bucket */
  preview_key_bucket: string
  /** 影片地址(預覽) */
  preview_url: string
  /** 商品金幣 */
  product_coin: number
  /**
   * 商品ID
   * @example "0"
   */
  product_id: string
  /**
   * 地區ID
   * @example "0"
   */
  region_id: string
  /** 排序 */
  seqno: number
  /** 顯示付費類型 (1:顯示 2:不顯示) */
  show_payment: number
  /** 是否顯示番號(1:是 2:否) */
  show_video_code: number
  /** 來源 */
  source: string
  /** 來源名稱 */
  source_name: string
  /** 上架状态(1:未上架 2:上架 3:下架) */
  state: number
  /** 状态(1:启用 2:停用) */
  status: number
  /** 同步到阿里時間 */
  sync_oss_at: string
  /** 標題 */
  title: string
  /** 話題 Ids */
  topic_ids: string[]
  /** 影片類別(1:長視頻 2:短視頻) */
  type: number
  /** 更新時間 */
  updated_at: string
  /** 上傳時間 */
  uploaded_at: string
  /** up主icon path */
  uploader_icon: string
  /**
   * up主ID
   * @example "0"
   */
  uploader_id: string
  /** up主名稱 */
  uploader_name: string
  /** up主影片數量(僅在detail api計算) */
  uploader_video_count: number
  /** 番號 */
  video_code: string
  /** 時長 (ex: 02:30:15.1234) */
  video_length: string
  /** 觀看數 */
  view_count: number
}

export interface SchemaShortVideoShowQueryResult {
  data: SchemaShortVideoShow[]
  page_result: SchemaPaginationResult
  /** @example "0" */
  topic_version: string
}

export interface SchemaShortVideoWaterfallResult {
  data: SchemaShortVideoShow[]
  has_more: boolean
}

export interface SchemaStationInfoResult {
  /** 中文名稱 */
  chinese_name: string
  /** aes128 for cover key */
  cover_key: string
  /** 是否啟用share */
  enable_share: boolean
  /** 站ID */
  id: number
  /** 是否為免費站 */
  is_free: boolean
  /** 是否為視頻管理站(for admin web) */
  is_video_manager: boolean
  /** 是否隨機挑選影片模式 */
  is_video_pick_mode: boolean
  /** 模式(主站:Main  分站:Copycat) */
  mode: string
  /** 名稱 */
  name: string
}

export interface SchemaStatusResult {
  status: SchemaStatusText
}

export enum SchemaStatusText {
  OKStatus = 'OK',
  ErrorStatus = 'ERROR',
  FailStatus = 'FAIL',
}

export interface SchemaSubproductShow {
  /** 金幣數量 */
  coin: number
  /** 金幣觀看天數 */
  coin_watch_days: number
  /** 建立時間 */
  created_at: string
  /**
   * ID
   * @example "0"
   */
  id: string
  /** 商品名稱 */
  name: string
  /** 排序 */
  seqno: number
  /** 状态(1:启用 2:停用) */
  status: number
  /** 商品類型(1:金幣 2:VIP 3:金幣觀看) */
  subproduct_type: number
  /** VIP天數 */
  vip_days: number
}

export interface SchemaSubproductShowQueryResult {
  data: SchemaSubproductShow[]
  page_result: SchemaPaginationResult
}

export interface SchemaSystemConfigShow {
  /** CDN類別(1:APP域名 2:H5專用域名) */
  cdn_kind: number
  /** 建立時間 */
  created_at: string
  /** 健康檢查(1:可使用 2:已被封鎖) */
  healthy: number
  /**
   * ID
   * @example "0"
   */
  id: string
  /** 備案域名(1:是 2:否) */
  is_backup_url: number
  /** 名稱 */
  name: string
  /** 防盜鏈(1:防盜鏈 2:非防盜鏈) */
  secret: number
  /** 状态(1:启用 2:停用) */
  status: number
  /** 類型(1:會員API加速域名 2:影片預覽加速域名 3:影片高清加速域名 4:支付回調加速域名 5:代理平台加速域名 6:android下載域名 7:圖片下載域名 8:referer域名 9:會員推薦分享域名 10:comic下載域名 11:novel下載域名) */
  type: number
  /** 更新時間 */
  updated_at: string
  /** 主域名 */
  url: string
}

export interface SchemaSystemConfigShowQueryResult {
  data: SchemaSystemConfigShow[]
  page_result: SchemaPaginationResult
}

export interface SchemaTagShow {
  /** 漫畫使用到的標籤總數 */
  comic_tag_count: number
  /** 建立时间 */
  created_at: string
  /** 操作人 */
  editor: string
  /** 圖片路徑 */
  icon_path: string
  /**
   * 唯一標識
   * @example "0"
   */
  id: string
  /** 標籤等級 */
  level: number
  /** 標籤名稱 */
  name: string
  /** 小說使用到的標籤總數 */
  novel_tag_count: number
  /**
   * 上級標籤
   * @example "0"
   */
  parent_id: string
  /** 上級名稱 */
  parent_name: string
  /** 是否推薦(1:是 2:否) */
  promote: number
  /** 排序 */
  seqno: number
  /** 状态(1:启用 2:停用) */
  status: number
  /** 標籤分類(1:視頻 2:漫畫 3:小說) */
  type: number
  /** 更新時間 */
  updated_at: string
  /** 長影片使用到的標籤總數(目前使用在長影片的二級標籤) */
  video_tag_count: number
}

export interface SchemaTagShowQueryResult {
  data: SchemaTagShow[]
  page_result: SchemaPaginationResult
}

export interface SchemaTempTokenInfo {
  /** 過期時間戳 */
  expires_at: number
  /** 臨時訪問令牌 */
  temp_access_token: string
}

export interface SchemaTopicShow {
  /** 建立时间 */
  created_at: string
  /** 操作人 */
  editor: string
  /** 圖片路徑 */
  icon_path: string
  /**
   * 唯一標識
   * @example "0"
   */
  id: string
  /** 話題名稱 */
  name: string
  /** 是否推薦(1:是 2:否) */
  promote: number
  /** 排序 */
  seqno: number
  /** 状态(1:启用 2:停用) */
  status: number
  /** 話數使用總數 */
  topic_count: number
  /** 更新時間 */
  updated_at: string
}

export interface SchemaTopicShowQueryResult {
  data: SchemaTopicShow[]
  page_result: SchemaPaginationResult
}

export interface SchemaTranserWalletBaseParam {
  /** 異動金額 */
  amount?: number
  /** 備註 */
  remark?: string
  /** 1:增加 2:扣點 */
  transfer_type?: number
}

export interface SchemaUpdatePasswordParam {
  /** 2fa code */
  code_2fa?: string
  /** 新密碼 */
  new_password: string
  /** 舊密碼 */
  old_password?: string
}

export interface SchemaVideoRegionShow {
  /** 演员排序 */
  actor_seqno: number
  /** 演员顯示状态(1:启用 2:停用) */
  actor_status: number
  /**
   * 唯一標識
   * @example "0"
   */
  id: string
  /** 地區種類(1:長視頻 2:短視頻 3:漫畫 4:小說) */
  kind: number
  /** 名稱 */
  name: string
  /** 挑選數量 */
  picked_number: number
  /** 排序 */
  seqno: number
  /** 状态(1:启用 2:停用) */
  status: number
  /** 類型(1:一般 2:長板) */
  type: number
}

export interface SchemaVideoRegionShowQueryResult {
  data: SchemaVideoRegionShow[]
  page_result: SchemaPaginationResult
}

export interface SchemaVideoShareInfoResult {
  /** 加密後的分享字串 */
  VideoShare: string
  /** 是否有H265格式 */
  haveH265: boolean
  /** 加密後的 CloudFront 簽章字串;base64 decode 後以 seed 684125365 XOR 還原,內容為逗號串接且順序固定:policy,signature,keyPairId,expiresAt,resource。resource 固定最後一段(URL 可能含逗號,只切前 4 個逗號)。未帶 resource 時不回傳 */
  cloudfront: string
}

export interface SchemaVideoShow {
  /** 演員 Ids */
  actor_ids: string[]
  /**
   * 演員地區ID
   * @example "0"
   */
  actor_region_id: string
  /** 是否用金幣買過影片 */
  buy_video: number
  /** 分類 Ids */
  category_ids: string[]
  /** 封面 (橫向) */
  coverphoto_h: string
  /** 封面 (縱向) */
  coverphoto_v: string
  /** 建立時間 */
  created_at: string
  /**
   * 執行人員
   * @example "0"
   */
  creator_id: string
  /** 執行人員名稱 */
  creator_user_name: string
  /** 描述 */
  description: string
  /** 收藏 (1:是 2:否) (僅在detail api計算) */
  favorite: number
  /** 收藏數 */
  favorite_count: number
  /** h265影片key */
  h265_key: string
  /** h265影片地址(高清) */
  h265_url: string
  /** 影片地址(高清) */
  highres_url: string
  /**
   * ID
   * @example "0"
   */
  id: string
  /** 是否同步到阿里(1:success 2:no sync 3:failed 4:going) */
  is_sync_oss: number
  /** 喜歡 (1:是 2:否) (僅在detail api計算) */
  like: number
  /** 點讚數 */
  like_count: number
  /** 下架時間 */
  off_shelf_at: string
  /** 上架時間 */
  on_shelf_at: string
  /** 原片番號 */
  ong_video: string
  /** 1:免費 2:金幣 3:VIP */
  payment_type: number
  /** prview key bucket */
  preview_key_bucket: string
  /** 影片地址(預覽) */
  preview_url: string
  /** 片商icon path */
  producer_icon: string
  /**
   * 片商ID
   * @example "0"
   */
  producer_id: string
  /** 片商名稱 */
  producer_name: string
  /** 片商影片數量(僅在detail api計算) */
  producer_video_count: number
  /** 商品金幣 */
  product_coin: number
  /**
   * 商品ID
   * @example "0"
   */
  product_id: string
  /**
   * 地區ID
   * @example "0"
   */
  region_id: string
  /** 排序 */
  seqno: number
  /** 顯示付費類型 (1:顯示 2:不顯示) */
  show_payment: number
  /** 是否顯示番號(1:是 2:否) */
  show_video_code: number
  /** 來源 */
  source: string
  /** 來源名稱 */
  source_name: string
  /** 上架状态(1:未上架 2:上架 3:下架) */
  state: number
  /** 状态(1:启用 2:停用) */
  status: number
  /** 同步到阿里時間 */
  sync_oss_at: string
  /** Tag Ids */
  tag_ids: string[]
  /** Tag Names */
  tag_names: string[]
  /** 標題 */
  title: string
  /** 話題 Ids */
  topic_ids: string[]
  /** 影片類別(1:長視頻 2:短視頻) */
  type: number
  /** 更新時間 */
  updated_at: string
  /** 上傳時間 */
  uploaded_at: string
  /** up主icon path */
  uploader_icon: string
  /**
   * up主ID
   * @example "0"
   */
  uploader_id: string
  /** up主名稱 */
  uploader_name: string
  /** up主影片數量(僅在detail api計算) */
  uploader_video_count: number
  /** 番號 */
  video_code: string
  /** 時長 (ex: 02:30:15.1234) */
  video_length: string
  /** 觀看數 */
  view_count: number
}

export interface SchemaVideoShowQueryResult {
  data: SchemaVideoShow[]
  page_result: SchemaPaginationResult
  /** @example "0" */
  tag_version: string
}

export interface SchemaVideoUploaderNameShow {
  /**
   * ID
   * @example "0"
   */
  id: string
  /** 片商名稱 */
  name: string
}

export interface SchemaVideoUploaderNameShowQueryResult {
  data: SchemaVideoUploaderNameShow[]
  page_result: SchemaPaginationResult
  /** @example "0" */
  tag_version: string
}

export interface SchemaVideoUploaderShow {
  /** 封面路徑 */
  cover_path: string
  /** 建立时间 */
  created_at: string
  /** 介紹 */
  description: string
  /** 粉絲數 */
  fans_count: number
  /** 喜歡次數 */
  favorite_count: number
  /** 圖片路徑 */
  icon_path: string
  /**
   * ID
   * @example "0"
   */
  id: string
  /** 喜歡次數 */
  like_count: number
  /** up主名稱 */
  name: string
  /** 状态(1:启用 2:停用) */
  status: number
  /** 更新時間 */
  updated_at: string
  /** 影片數量 */
  video_num: number
}

export interface SchemaVideoUploaderShowQueryResult {
  data: SchemaVideoUploaderShow[]
  page_result: SchemaPaginationResult
  /** @example "0" */
  tag_version: string
}

export interface SchemaVideoViewParam {
  /**
   * video id
   * @example "0"
   */
  video_id?: string
}

export interface FetchAnnouncementBaseParams {
  /** 裝置類型(ios,android,cookie) */
  device_type?: string
  /** 當前頁碼 */
  current?: number
  /** 每頁數量 */
  pageSize?: number
  /** 查詢僅回總數(1:是 2:否) */
  only_count?: number
}

export interface FetchCmsPublishResultParams {
  /** 平台ID */
  site_id?: number
}

export interface FetchCmsPublishResultV2Params {
  /** 平台ID */
  site_id?: number
}

export interface FetchCmsPublishResultV4Params {
  /** 平台ID */
  site_id?: number
}

export interface FetchCmsPublishResultV5Params {
  /** 平台ID */
  site_id?: number
}

export interface V1CmsPublishResultV6ListParams {
  /** 平台ID */
  site_id?: number
}

export interface FetchCmsPublishResultV7Params {
  /** 平台ID */
  site_id?: number
}

export interface FetchComicListBaseParams {
  /** 標題 */
  title?: string
  /** 漫畫ID */
  id?: number
  /** 漫畫編號 */
  comic_code?: string
  /** 連載狀態(1:連載 2:完結) */
  serial?: number
  /** 地區(1:日漫 2:韓漫) */
  region?: number
  /** 地區IDs(逗號分隔) */
  region_ids?: string
  /** 標籤IDs(逗號分隔) */
  tag_ids?: string
  /** 分類IDs(逗號分隔) */
  category_ids?: string
  /** 付費類型(1:免費 2:金幣 3:VIP) */
  payment_type?: number
  /** 收藏歷史(1:是 2:否) */
  favorite_history?: number
  /** 觀看歷史(1:是 2:否) */
  view_history?: number
  /** 購買歷史(1:是 2:否) */
  buy_history?: number
  /** 來源站 */
  source?: string
  /** 標籤數量 */
  tag_num?: number
  /** 已貼標(1:是 2:否) */
  tagged?: number
  /** 上架時間起(ex:2022-03-21 23:50:27) */
  on_shelf_at_begin?: string
  /** 上架時間迄(ex:2022-03-21 23:50:27) */
  on_shelf_at_end?: string
  /** 排序方式(created_at,updated_at,hot,on_shelf_at,view_count,-view_count,random,vip_first) */
  sortby?: string
  /** 當前頁碼 */
  current?: number
  /** 每頁數量 */
  pageSize?: number
  /** 查詢僅回總數(1:是 2:否) */
  only_count?: number
}

export interface FetchComicChaptersBaseParams {
  /**
   * 章節ID
   * @format int64
   */
  id?: number
  /**
   * 漫畫ID
   * @format int64
   */
  comic_id?: number
  /** 漫畫名稱 */
  comic_title?: string
  /** 章節名稱 */
  title?: string
  /** 同步OSS狀態(1:success 2:no sync 3:failed 4:going) */
  is_sync_oss?: number
  /** 當前頁碼 */
  current?: number
  /** 每頁數量 */
  pageSize?: number
  /** 查詢僅回總數(1:是 2:否) */
  only_count?: number
}

export interface FetchCooperationBaseParams {
  /** 位置(1:落地頁 2:APP) */
  site_id?: number
  /** 名稱 */
  name?: string
  /** 當前頁碼 */
  current?: number
  /** 每頁數量 */
  pageSize?: number
  /** 查詢僅回總數(1:是 2:否) */
  only_count?: number
}

export interface FetchMemberPromoteListParams {
  /** 當前頁碼 */
  current?: number
  /** 每頁數量 */
  pageSize?: number
  /** 查詢僅回總數(1:是 2:否) */
  only_count?: number
}

export interface V1MemberAnnounceListParams {
  /** 裝置類型(ios,android,cookie) */
  device_type?: string
  /** 當前頁碼 */
  current?: number
  /** 每頁數量 */
  pageSize?: number
}

export interface FetchNovelListBaseParams {
  /** 頁碼 */
  current?: number
  /** 每頁數量 */
  pageSize?: number
  /** 標題 */
  title?: string
  /** 小說ID */
  id?: number
  /** 小說編號 */
  novel_code?: string
  /** 作者 */
  author?: string
  /** 連載狀態(1:連載 2:完結) */
  serial?: number
  /** 標籤IDs(逗號分隔) */
  tag_ids?: string
  /** 分類IDs(逗號分隔) */
  category_ids?: string
  /** 地區IDs(逗號分隔) */
  region_ids?: string
  /** 付費類型(1:免費 2:金幣 3:VIP) */
  payment_type?: number
  /** 收藏歷史(1:是 2:否) */
  favorite_history?: number
  /** 觀看歷史(1:是 2:否) */
  view_history?: number
  /** 購買歷史(1:是 2:否) */
  buy_history?: number
  /** 來源站 */
  source?: string
  /** 標籤數量 */
  tag_num?: number
  /** 已貼標(1:是 2:否) */
  tagged?: number
  /** 上架時間起(ex:2022-03-21 23:50:27) */
  on_shelf_at_begin?: string
  /** 上架時間迄(ex:2022-03-21 23:50:27) */
  on_shelf_at_end?: string
  /** 排序欄位(created_at,updated_at,hot,on_shelf_at,view_count,-view_count,random,vip_first) */
  sortby?: string
  /** 查詢僅回總數(1:是 2:否) */
  only_count?: number
}

export interface FetchNovelChaptersBaseParams {
  /**
   * 章節ID
   * @format int64
   */
  id?: number
  /**
   * 小說ID
   * @format int64
   */
  novel_id?: number
  /** 小說名稱 */
  novel_title?: string
  /** 章節名稱 */
  title?: string
  /** 同步OSS狀態(1:是 2:否) */
  is_sync_oss?: number
  /** 當前頁碼 */
  current?: number
  /** 每頁數量 */
  pageSize?: number
  /** 查詢僅回總數(1:是 2:否) */
  only_count?: number
}

export interface FetchAdListV1Params {
  /** 略過的筆數 */
  base_offset?: number
  current?: number
  /** 過期狀態(1:未到期 2:到期) */
  expire_status?: number
  /** 內部跳轉類型 (1: NAV ID(default) 2:遊戲ID 3:片商ID 4:演員ID, 5:片商列表, 6:演員列表, 7:開通VIP)) */
  internal_type?: number
  /** 是否所有頻道(1:自動全選 2:人工設定) ps: only for 16.金剛區廣告 */
  is_all_tab?: number
  /** 素材Type (1:內部 2:外部) */
  link_type?: number
  /** 素材名稱 */
  name?: string
  /** 金主ID */
  oholoer_id?: number
  /** 金主名稱 */
  oholoer_name?: string
  /** 金主狀態 */
  oholoer_status?: number
  /** 查詢僅回總數 (1:是 2:否) */
  only_count?: number
  /** @max 3000 */
  pageSize?: number
  /** 版位ID */
  site_id?: number
  /** 版位類型(1. 启动页 2. 频道轮播 3. 橱窗下方 4. 橱窗更多 5. 橱窗中 6. 播放页面 7. 个人中心 8. 公告弹窗 9. 应用轮播 10. 应用图标5 11. 发现 12. 应用图标2 13. 应用图标3  14. 短视频广告位  15. 区域影片广告位 16.金剛區廣告 17. 瀑布流滿版廣告位 18. 瀑布流浮窗廣告位) */
  site_type?: number
  /** 版位類型str ,串接 */
  site_types?: string
  /** 開始狀態(1:開始 2:未開始) */
  start_status?: number
  /** 状态(1:启用 2:停用) 會員端永遠只能查啟用 無須帶此參數 */
  status?: number
}

export interface FetchAdListBaseParams {
  /** 略過的筆數 */
  base_offset?: number
  current?: number
  /** 過期狀態(1:未到期 2:到期) */
  expire_status?: number
  /** 內部跳轉類型 (1: NAV ID(default) 2:遊戲ID 3:片商ID 4:演員ID, 5:片商列表, 6:演員列表, 7:開通VIP)) */
  internal_type?: number
  /** 是否所有頻道(1:自動全選 2:人工設定) ps: only for 16.金剛區廣告 */
  is_all_tab?: number
  /** 素材Type (1:內部 2:外部) */
  link_type?: number
  /** 素材名稱 */
  name?: string
  /** 金主ID */
  oholoer_id?: number
  /** 金主名稱 */
  oholoer_name?: string
  /** 金主狀態 */
  oholoer_status?: number
  /** 查詢僅回總數 (1:是 2:否) */
  only_count?: number
  /** @max 3000 */
  pageSize?: number
  /** 版位ID */
  site_id?: number
  /** 版位類型(1. 启动页 2. 频道轮播 3. 橱窗下方 4. 橱窗更多 5. 橱窗中 6. 播放页面 7. 个人中心 8. 公告弹窗 9. 应用轮播 10. 应用图标5 11. 发现 12. 应用图标2 13. 应用图标3  14. 短视频广告位  15. 区域影片广告位 16.金剛區廣告 17. 瀑布流滿版廣告位 18. 瀑布流浮窗廣告位) */
  site_type?: number
  /** 版位類型str ,串接 */
  site_types?: string
  /** 開始狀態(1:開始 2:未開始) */
  start_status?: number
  /** 状态(1:启用 2:停用) 會員端永遠只能查啟用 無須帶此參數 */
  status?: number
}

export interface FetchProductListBaseParams {
  /** 商品名稱 */
  name?: string
  /** 商品類型(1:金幣 2:VIP) */
  product_type?: number
  /** 狀態(1:啟用 2:停用) */
  status?: number
  /** 是否返傭(1:是 2:否) */
  rebate?: number
  /** 當前頁碼 */
  current?: number
  /** 每頁數量 */
  pageSize?: number
  /** 查詢僅回總數(1:是 2:否) */
  only_count?: number
}

export interface FetchProductVideoListParams {
  /** 商品名稱 */
  name?: string
  /** 狀態(1:啟用 2:停用) */
  status?: number
  /** 當前頁碼 */
  current?: number
  /** 每頁數量 */
  pageSize?: number
  /** 查詢僅回總數(1:是 2:否) */
  only_count?: number
}

export interface V1ProductSubproductListParams {
  /** 子商品名稱 */
  name?: string
  /** 當前頁碼 */
  current?: number
  /** 每頁數量 */
  pageSize?: number
}

export interface GetLandingDomainsBaseParams {
  /** 代理帳號(精準查詢；帶此參數時 domain_name 會接上 ?c={邀請碼}) */
  user_name_eq?: string
  /** 當前頁碼 */
  current?: number
  /** 每頁數量 */
  pageSize?: number
  /** 查詢僅回總數(1:是 2:否) */
  only_count?: number
}

export interface FetchSystemCdnParams {
  /** 當前頁碼 */
  current?: number
  /** 每頁數量 */
  pageSize?: number
  /** 查詢僅回總數(1:是 2:否) */
  only_count?: number
}

export interface FetchVideoListBaseParams {
  /** 頁碼 */
  current?: number
  /** 每頁數量 */
  pageSize?: number
  /** 視頻ID */
  id?: number
  /** 番號 */
  video_code?: string
  /** 標題 */
  title?: string
  /** 關鍵字 */
  keyword?: string
  /** 分類IDs(逗號分隔, ex: 1,2,3) */
  category_ids?: string
  /** 標籤IDs(逗號分隔) */
  tag_ids?: string
  /** 話題IDs(逗號分隔) */
  topic_ids?: string
  /** 演員IDs(逗號分隔) */
  actor_ids?: string
  /** 片商ID */
  producer_id?: number
  /** 片商IDs(逗號分隔) */
  producer_ids?: string
  /** 地區ID */
  region_id?: number
  /** 地區IDs(逗號分隔) */
  region_ids?: string
  /** 付費類型(1:免費 2:金幣 3:VIP) */
  payment_type?: number
  /** 排序欄位(view_count,-view_count,created_at,on_shelf_at,hot,complex,7_days_hot,14_days_hot,30_days_hot,days_hot,month_hot) */
  sortby?: string
  /** 自訂熱門天數結束(搭配days_hot, 1-30, 代表幾天前的遠端) */
  hot_days?: number
  /** 自訂熱門天數起始(搭配days_hot, 0=今天, 代表幾天前的近端) */
  hot_days_start?: number
  /** 自訂熱門月份(搭配month_hot, 格式YYYY-MM, 多月份逗號分隔最多12個瀏覽數加總, ex:2026-06,2026-07) */
  hot_month?: string
  /** 自訂熱門年份(搭配year_hot, 格式YYYY, ex:2026) */
  hot_year?: string
  /** 推薦類型(1:女優 2:廠商 99:全選) */
  recommend?: number
  /** 特殊搜尋(1:排行榜) */
  special_search?: number
  /** 觀看歷史(1:是 2:否) */
  watch_history?: number
  /** 購買歷史(1:是 2:否) */
  buy_history?: number
  /** 收藏歷史(1:是 2:否) */
  favorite_history?: number
  /** 喜歡歷史(1:是 2:否) */
  like_history?: number
  /** 最熱影片(1:是 2:否) */
  hot_video?: number
  /** 詳細查詢-單部ID查詢用(1:是 2:否) */
  detail?: number
  /** 來源站 */
  source?: string
  /** 挑選(1:是 2:否) */
  picked?: number
  /** 是否顯示番號(1:是 2:否) */
  show_video_code?: number
  /** 標籤數量 */
  tag_num?: number
  /** 貼標狀態(0:全部 1:已貼標 2:未貼標) */
  tag_status?: number
  /** UP主狀態(0:全部 1:啟用 2:停用) */
  uploader_status?: number
  /** 是否指定查番號(1:使用 2:不使用) */
  is_specify_video_code?: number
  /** 同步OSS狀態(1:success 2:no sync 3:failed 4:going) */
  is_sync_oss?: number
  /** 上架時間起(ex:2022-03-21 23:50:27) */
  on_shelf_at_begin?: string
  /** 上架時間迄 */
  on_shelf_at_end?: string
  /** 建立時間起(ex:2022-03-21 23:50:27) */
  created_at_begin?: string
  /** 建立時間迄 */
  created_at_end?: string
  /** 查詢僅回總數(1:是 2:否) */
  only_count?: number
}

export interface FetchActorListBaseParams {
  /** 演員IDs(逗號分隔) */
  ids?: string
  /** 演員名稱 */
  name?: string
  /** 演員原名 */
  orig_name?: string
  /** 性別(1:男 2:女) */
  gender?: number
  /** 狀態(1:啟用 2:停用) */
  status?: number
  /** 區域ID */
  region_id?: number
  /** 推薦(1:是 2:否) */
  recommend?: number
  /** 發現頁(1:啟用 2:停用) */
  discover_page?: number
  /** 排序方式(recommend,-recommend,created_at,-created_at) */
  sortby?: string
  /** 頁碼 */
  current?: number
  /** 每頁數量 */
  pageSize?: number
  /** 查詢僅回總數(1:是 2:否) */
  only_count?: number
}

export interface FetchActorNameListParams {
  /** 演員名稱 */
  name?: string
  /** 狀態(1:啟用 2:停用) */
  status?: number
  /** 頁碼 */
  current?: number
  /** 每頁數量 */
  pageSize?: number
}

export interface V1VideoIosKeyDetailParams {
  /** 認證令牌 */
  value: string
  /** 視頻ID */
  id: number
}

export interface FetchVideoM3U8Params {
  /** 認證令牌 */
  value: string
  /** 視頻ID */
  id: number
}

export interface FetchProducerListBaseParams {
  /** 片商名稱 */
  name?: string
  /** 狀態(1:啟用 2:停用) */
  status?: number
  /** 推薦(1:啟用 2:停用) */
  recommend?: number
  /** 片商類型(1:無 2:國產傳媒 3:AV廠商 4:UP原創 5:剪輯達人) */
  producer_type?: number
  /** 排序方式(name,-name) */
  sortby?: string
  /** 頁碼 */
  current?: number
  /** 每頁數量 */
  pageSize?: number
  /** 查詢僅回總數(1:是 2:否) */
  only_count?: number
}

export interface FetchProducerNameListParams {
  /** 片商名稱 */
  name?: string
  /** 狀態(1:啟用 2:停用) */
  status?: number
  /** 頁碼 */
  current?: number
  /** 每頁數量 */
  pageSize?: number
}

export interface FetchRegionListBaseParams {
  /** 地區名稱 */
  name?: string
  /** 地區種類(1:長視頻 2:短視頻 3:漫畫 4:小說) */
  kind?: number
  /** 當前頁碼 */
  current?: number
  /** 每頁數量 */
  pageSize?: number
}

export interface FetchShortListBaseParams {
  /** 頁碼 */
  current?: number
  /** 每頁數量 */
  pageSize?: number
  /** 視頻ID */
  id?: number
  /** 番號 */
  video_code?: string
  /** 標題 */
  title?: string
  /** 分類IDs(逗號分隔) */
  category_ids?: string
  /** 話題IDs(逗號分隔) */
  topic_ids?: string
  /** 地區ID */
  region_id?: number
  /** 地區IDs(逗號分隔) */
  region_ids?: string
  /** UP主ID */
  uploader_id?: number
  /** 付費類型(1:免費 2:金幣 3:VIP) */
  payment_type?: number
  /** 排序欄位(view_count,-view_count,created_at,on_shelf_at,hot,vip_first,7_days_hot,14_days_hot,30_days_hot,days_hot,month_hot) */
  sortby?: string
  /** 自訂熱門天數結束(搭配days_hot, 1-30, 代表幾天前的遠端) */
  hot_days?: number
  /** 自訂熱門天數起始(搭配days_hot, 0=今天, 代表幾天前的近端) */
  hot_days_start?: number
  /** 自訂熱門月份(搭配month_hot, 格式YYYY-MM, 多月份逗號分隔最多12個瀏覽數加總, ex:2026-06,2026-07) */
  hot_month?: string
  /** 自訂熱門年份(搭配year_hot, 格式YYYY, ex:2026) */
  hot_year?: string
  /** 特殊搜尋(1:排行榜) */
  special_search?: number
  /** 觀看歷史(1:是 2:否) */
  watch_history?: number
  /** 購買歷史(1:是 2:否) */
  buy_history?: number
  /** 收藏歷史(1:是 2:否) */
  favorite_history?: number
  /** 喜歡歷史(1:是 2:否) */
  like_history?: number
  /** 詳細查詢-單部ID查詢用(1:是 2:否) */
  detail?: number
  /** 來源站 */
  source?: string
  /** 是否顯示番號(1:是 2:否) */
  show_video_code?: number
  /** 貼標狀態(0:全部 1:已貼標 2:未貼標) */
  tag_status?: number
  /** 話題數量 */
  topic_num?: number
  /** UP主狀態(0:全部 1:啟用 2:停用) */
  uploader_status?: number
  /** 上架時間起(ex:2022-03-21 23:50:27) */
  on_shelf_at_begin?: string
  /** 上架時間迄 */
  on_shelf_at_end?: string
  /** 建立時間起(ex:2022-03-21 23:50:27) */
  created_at_begin?: string
  /** 建立時間迄 */
  created_at_end?: string
  /** 查詢僅回總數(1:是 2:否) */
  only_count?: number
}

export interface FetchShortWaterfallListParams {
  /** 每頁數量(最大50) */
  pageSize?: number
}

export interface FetchVideoTagListBaseParams {
  /** 標籤ID */
  id?: number
  /** 標籤名稱 */
  name?: string
  /** 標籤等級(1或2) */
  level?: number
  /** 上級標籤ID */
  parent_id?: number
  /** 是否推薦(1:是 2:否) */
  promote?: number
  /** 標籤分類(1:視頻 2:漫畫 3:小說) */
  type?: number
  /** 操作人 */
  editor?: string
  /** 排序 */
  seqno?: number
  /** 後台來源(1:基礎管理 2:視頻管理) */
  source_type?: number
  /** 排序方式(seqno,-seqno,video_tag_count,-video_tag_count) */
  sortby?: string
  /** 頁碼 */
  current?: number
  /** 每頁數量 */
  pageSize?: number
  /** 查詢僅回總數(1:是 2:否) */
  only_count?: number
}

export interface FetchVideoTopicListBaseParams {
  /** 話題ID */
  id?: number
  /** 話題名稱 */
  name?: string
  /** 是否推薦(1:是 2:否) */
  promote?: number
  /** 操作人 */
  editor?: string
  /** 排序 */
  seqno?: number
  /** 後台來源(1:基礎管理 2:視頻管理) */
  source_type?: number
  /** 排序方式(seqno,-seqno,topic_count,-topic_count) */
  sortby?: string
  /** 頁碼 */
  current?: number
  /** 每頁數量 */
  pageSize?: number
  /** 查詢僅回總數(1:是 2:否) */
  only_count?: number
}

export interface FetchUploaderListBaseParams {
  /** 當前頁碼 */
  current?: number
  /** 每頁數量 */
  pageSize?: number
  /** 查詢僅回總數(1:是 2:否) */
  only_count?: number
  /** 上傳者ID */
  id?: number
  /** 上傳者名稱 */
  name?: string
  /** 發現頁狀態(1:啟用 2:停用),從發現頁進入時帶1 */
  discover_status?: number
}

export interface FetchUploaderNameListParams {
  /** 當前頁碼 */
  current?: number
  /** 每頁數量 */
  pageSize?: number
  /** 查詢僅回總數(1:是 2:否) */
  only_count?: number
  /** 上傳者ID */
  id?: number
  /** 上傳者名稱 */
  name?: string
}

// This file is auto-generated. Do not edit manually.
// Run `npm run generate-api` to regenerate.
/* eslint-disable */
/* tslint:disable */

import { fetchApi } from './config'

/**
 * No description *
 * @tags _Member, Business
 * @name FetchAnnouncementBase
 * @summary 會員查詢公告列表
 * @request GET:/api/v1/announce
 * @secure */
export function fetchAnnouncementBase(
  query?: {
    /** 裝置類型(ios,android,cookie) */
    device_type?: string
    /** 當前頁碼 */
    current?: number
    /** 每頁數量 */
    pageSize?: number
    /** 查詢僅回總數(1:是 2:否) */
    only_count?: number
  },
  signal?: AbortSignal
): Promise<SchemaAnnounceShowQueryResult> {
  return fetchApi({ url: '/announce', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, SystemConfig
 * @name V1CheckRealCreate
 * @summary 會員檢查API可用性
 * @request POST:/api/v1/check/real
 * @secure */
export function v1CheckRealCreate(request: SchemaCheckApi, signal?: AbortSignal): Promise<SchemaStatusResult> {
  return fetchApi({ url: '/check/real', method: 'POST', data: request, signal })
}
/**
 * No description *
 * @tags _Member, CMS
 * @name PostCmsEvent
 * @summary 會員創建CMS活動
 * @request POST:/api/v1/cms/event
 * @secure */
export function postCmsEvent(request: SchemaCmsEventCreateParam, signal?: AbortSignal): Promise<SchemaStatusResult> {
  return fetchApi({ url: '/cms/event', method: 'POST', data: request, signal })
}
/**
 * No description *
 * @tags _Member, CMS
 * @name FetchCmsPublishResult
 * @summary 查詢CMS發布結果
 * @request GET:/api/v1/cms/publish/result
 * @secure */
export function fetchCmsPublishResult(
  query?: {
    /** 平台ID */
    site_id?: number
  },
  signal?: AbortSignal
): Promise<SchemaCmsPublishResult[]> {
  return fetchApi({ url: '/cms/publish/result', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, CMS
 * @name FetchCmsPublishResultV2
 * @summary 查詢CMS發布結果V2
 * @request GET:/api/v1/cms/publish/result_v2
 * @secure */
export function fetchCmsPublishResultV2(
  query?: {
    /** 平台ID */
    site_id?: number
  },
  signal?: AbortSignal
): Promise<SchemaCmsPublishResult[]> {
  return fetchApi({ url: '/cms/publish/result_v2', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, CMS
 * @name FetchCmsPublishResultV4
 * @summary 查詢CMS發布結果V4
 * @request GET:/api/v1/cms/publish/result_v4
 * @secure */
export function fetchCmsPublishResultV4(
  query?: {
    /** 平台ID */
    site_id?: number
  },
  signal?: AbortSignal
): Promise<SchemaCmsPublishResult[]> {
  return fetchApi({ url: '/cms/publish/result_v4', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, CMS
 * @name FetchCmsPublishResultV5
 * @summary 查詢CMS發布結果V5
 * @request GET:/api/v1/cms/publish/result_v5
 * @secure */
export function fetchCmsPublishResultV5(
  query?: {
    /** 平台ID */
    site_id?: number
  },
  signal?: AbortSignal
): Promise<SchemaCmsPublishResult[]> {
  return fetchApi({ url: '/cms/publish/result_v5', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, CMS
 * @name V1CmsPublishResultV6List
 * @summary 查詢CMS發布結果V6
 * @request GET:/api/v1/cms/publish/result_v6
 * @secure */
export function v1CmsPublishResultV6List(
  query?: {
    /** 平台ID */
    site_id?: number
  },
  signal?: AbortSignal
): Promise<SchemaCmsPublishResult[]> {
  return fetchApi({ url: '/cms/publish/result_v6', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, CMS
 * @name FetchCmsPublishResultV7
 * @summary 查詢CMS發布結果V7
 * @request GET:/api/v1/cms/publish/result_v7
 * @secure */
export function fetchCmsPublishResultV7(
  query?: {
    /** 平台ID */
    site_id?: number
  },
  signal?: AbortSignal
): Promise<SchemaCmsPublishResult[]> {
  return fetchApi({ url: '/cms/publish/result_v7', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, Comic
 * @name FetchComicListBase
 * @summary 會員查詢漫畫列表
 * @request GET:/api/v1/comic
 * @secure */
export function fetchComicListBase(
  query?: {
    /** 標題 */
    title?: string
    /** 漫畫ID */
    id?: number
    /** 漫畫編號 */
    comic_code?: string
    /** 連載狀態(1:連載 2:完結) */
    serial?: number
    /** 地區(1:日漫 2:韓漫) */
    region?: number
    /** 地區IDs(逗號分隔) */
    region_ids?: string
    /** 標籤IDs(逗號分隔) */
    tag_ids?: string
    /** 分類IDs(逗號分隔) */
    category_ids?: string
    /** 付費類型(1:免費 2:金幣 3:VIP) */
    payment_type?: number
    /** 收藏歷史(1:是 2:否) */
    favorite_history?: number
    /** 觀看歷史(1:是 2:否) */
    view_history?: number
    /** 購買歷史(1:是 2:否) */
    buy_history?: number
    /** 來源站 */
    source?: string
    /** 標籤數量 */
    tag_num?: number
    /** 已貼標(1:是 2:否) */
    tagged?: number
    /** 上架時間起(ex:2022-03-21 23:50:27) */
    on_shelf_at_begin?: string
    /** 上架時間迄(ex:2022-03-21 23:50:27) */
    on_shelf_at_end?: string
    /** 排序方式(created_at,updated_at,hot,on_shelf_at,view_count,-view_count,random,vip_first) */
    sortby?: string
    /** 當前頁碼 */
    current?: number
    /** 每頁數量 */
    pageSize?: number
    /** 查詢僅回總數(1:是 2:否) */
    only_count?: number
  },
  signal?: AbortSignal
): Promise<SchemaComicShowQueryResult> {
  return fetchApi({ url: '/comic', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, Comic
 * @name FetchComicChaptersBase
 * @summary 會員查詢漫畫章節列表
 * @request GET:/api/v1/comic/chapter
 * @secure */
export function fetchComicChaptersBase(
  query?: {
    /**
     * 章節ID
     * @format int64
     */
    id?: number
    /**
     * 漫畫ID
     * @format int64
     */
    comic_id?: number
    /** 漫畫名稱 */
    comic_title?: string
    /** 章節名稱 */
    title?: string
    /** 同步OSS狀態(1:success 2:no sync 3:failed 4:going) */
    is_sync_oss?: number
    /** 當前頁碼 */
    current?: number
    /** 每頁數量 */
    pageSize?: number
    /** 查詢僅回總數(1:是 2:否) */
    only_count?: number
  },
  signal?: AbortSignal
): Promise<SchemaComicChapterShowQueryResult> {
  return fetchApi({ url: '/comic/chapter', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, Comic
 * @name FetchComicChapterKey
 * @summary 取得章節Key
 * @request POST:/api/v1/comic/chapter/key/{id}
 * @secure */
export function fetchComicChapterKey(id: number, signal?: AbortSignal): Promise<SchemaComicKeyResult> {
  return fetchApi({ url: `/comic/chapter/key/${id}`, method: 'POST', signal })
}
/**
 * No description *
 * @tags _Member, Comic
 * @name FetchComicViewChapter
 * @summary 記錄章節觀看數
 * @request POST:/api/v1/comic/chapter/view
 * @secure */
export function fetchComicViewChapter(
  request: SchemaChapterViewParam,
  signal?: AbortSignal
): Promise<SchemaStatusResult> {
  return fetchApi({ url: '/comic/chapter/view', method: 'POST', data: request, signal })
}
/**
 * No description *
 * @tags _Member, Business
 * @name FetchCooperationBase
 * @summary 會員查詢合作列表
 * @request GET:/api/v1/cooperation
 * @secure */
export function fetchCooperationBase(
  query?: {
    /** 位置(1:落地頁 2:APP) */
    site_id?: number
    /** 名稱 */
    name?: string
    /** 當前頁碼 */
    current?: number
    /** 每頁數量 */
    pageSize?: number
    /** 查詢僅回總數(1:是 2:否) */
    only_count?: number
  },
  signal?: AbortSignal
): Promise<SchemaCooperationShowQueryResult> {
  return fetchApi({ url: '/cooperation', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, CreCenter
 * @name PostCreCenterChangeToken
 * @summary 會員更新創作者中心令牌
 * @request POST:/api/v1/cre_center/change_token
 * @secure */
export function postCreCenterChangeToken(signal?: AbortSignal): Promise<SchemaStatusResult> {
  return fetchApi({ url: '/cre_center/change_token', method: 'POST', signal })
}
/**
 * No description *
 * @tags _Member, ErrHistory
 * @name PostErrHistory
 * @summary 建立錯誤歷史記錄
 * @request POST:/api/v1/err_history
 * @secure */
export function postErrHistory(request: SchemaErrHistoryCreateParam, signal?: AbortSignal): Promise<SchemaErrHistory> {
  return fetchApi({ url: '/err_history', method: 'POST', data: request, signal })
}
/**
 * No description *
 * @tags _Member, Event
 * @name PostEventOholo
 * @summary 會員創建Oholo活動事件
 * @request POST:/api/v1/event/oholo
 * @secure */
export function postEventOholo(
  item: SchemaOholoEventCreateParam,
  signal?: AbortSignal
): Promise<SchemaOholoEventCreateResp> {
  return fetchApi({ url: '/event/oholo', method: 'POST', data: item, signal })
}
/**
 * No description *
 * @tags _Member, Business
 * @name PostKefuWorkOrder
 * @summary 會員創建客服工單
 * @request POST:/api/v1/kefu/kefu_work_order
 * @secure */
export function postKefuWorkOrder(
  request: SchemaKefuWorkOrderCreateParam,
  signal?: AbortSignal
): Promise<SchemaKefuWorkOrder> {
  return fetchApi({ url: '/kefu/kefu_work_order', method: 'POST', data: request, signal })
}
/**
 * No description *
 * @tags _Member, Business
 * @name V1KefuKefuWorkOrderVisitorCreate
 * @summary 訪客創建客服工單
 * @request POST:/api/v1/kefu/kefu_work_order/visitor */
export function v1KefuKefuWorkOrderVisitorCreate(
  request: SchemaKefuWorkOrderCreateParam,
  signal?: AbortSignal
): Promise<SchemaKefuWorkOrder> {
  return fetchApi({ url: '/kefu/kefu_work_order/visitor', method: 'POST', data: request, signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name PutMember
 * @summary 編輯會員資訊
 * @request PUT:/api/v1/member
 * @secure */
export function putMember(request: SchemaMemberEditParam, signal?: AbortSignal): Promise<SchemaStatusResult> {
  return fetchApi({ url: '/member', method: 'PUT', data: request, signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name FetchDeviceQrcode
 * @summary 獲取綁定資訊
 * @request GET:/api/v1/member/bind_dev
 * @secure */
export function fetchDeviceQrcode(signal?: AbortSignal): Promise<SchemaMemberBindResult> {
  return fetchApi({ url: '/member/bind_dev', method: 'GET', signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name FetchFindPreviousAccount
 * @summary 綁定設備
 * @request POST:/api/v1/member/bind_dev
 * @secure */
export function fetchFindPreviousAccount(
  request: SchemaMemberBindDevParam,
  signal?: AbortSignal
): Promise<SchemaMemberShow> {
  return fetchApi({ url: '/member/bind_dev', method: 'POST', data: request, signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name PostMemberBindPromote
 * @summary 綁定推廣碼
 * @request POST:/api/v1/member/bind_promote
 * @secure */
export function postMemberBindPromote(
  request: SchemaBindPromoteCodeParam,
  signal?: AbortSignal
): Promise<SchemaStatusResult> {
  return fetchApi({ url: '/member/bind_promote', method: 'POST', data: request, signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name PostMemberDevice
 * @summary 會員設備註冊
 * @request POST:/api/v1/member/device */
export function postMemberDevice(
  request: SchemaMemberDeviceParam,
  signal?: AbortSignal
): Promise<SchemaLoginTokenInfo> {
  return fetchApi({ url: '/member/device', method: 'POST', data: request, signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name FetchMemberEstablish
 * @summary H5會員設備註冊
 * @request POST:/api/v1/member/establish */
export function fetchMemberEstablish(
  request: SchemaMemberDeviceParam,
  signal?: AbortSignal
): Promise<SchemaLoginTokenInfo> {
  return fetchApi({ url: '/member/establish', method: 'POST', data: request, signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name V1MemberExchangeTokenCreate
 * @summary 用臨時令牌交換真正的會員令牌
 * @request POST:/api/v1/member/exchange-token */
export function v1MemberExchangeTokenCreate(
  request: SchemaExchangeTempTokenParam,
  signal?: AbortSignal
): Promise<SchemaLoginTokenInfo> {
  return fetchApi({ url: '/member/exchange-token', method: 'POST', data: request, signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name FetchLogin
 * @summary 會員登入
 * @request POST:/api/v1/member/login
 * @secure */
export function fetchLogin(request: SchemaMemberLoginParam, signal?: AbortSignal): Promise<SchemaLoginTokenInfo> {
  return fetchApi({ url: '/member/login', method: 'POST', data: request, signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name FetchUserInfo
 * @summary 獲取當前會員資訊
 * @request GET:/api/v1/member/me
 * @secure */
export function fetchUserInfo(signal?: AbortSignal): Promise<SchemaMemberShow> {
  return fetchApi({ url: '/member/me', method: 'GET', signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name V1MemberPasswordUpdate
 * @summary 更新會員密碼
 * @request PUT:/api/v1/member/password
 * @secure */
export function v1MemberPasswordUpdate(
  request: SchemaUpdatePasswordParam,
  signal?: AbortSignal
): Promise<SchemaStatusResult> {
  return fetchApi({ url: '/member/password', method: 'PUT', data: request, signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name FetchVerificationCode
 * @summary 獲取手機驗證碼
 * @request POST:/api/v1/member/phone
 * @secure */
export function fetchVerificationCode(
  request: SchemaMemberPhoneCodeParam,
  signal?: AbortSignal
): Promise<SchemaMemberPhoneCodeResult> {
  return fetchApi({ url: '/member/phone', method: 'POST', data: request, signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name FetchMemberPromoteList
 * @summary 查詢推廣列表
 * @request GET:/api/v1/member/promote_list
 * @secure */
export function fetchMemberPromoteList(
  query?: {
    /** 當前頁碼 */
    current?: number
    /** 每頁數量 */
    pageSize?: number
    /** 查詢僅回總數(1:是 2:否) */
    only_count?: number
  },
  signal?: AbortSignal
): Promise<SchemaMemberPromoteRelShowQueryResult> {
  return fetchApi({ url: '/member/promote_list', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name FetchMemberPromoteUrl
 * @summary 獲取推廣連結
 * @request GET:/api/v1/member/promote_url
 * @secure */
export function fetchMemberPromoteUrl(signal?: AbortSignal): Promise<SchemaPromoteUrlCodeResult> {
  return fetchApi({ url: '/member/promote_url', method: 'GET', signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name FetchRefreshToken
 * @summary 刷新會員令牌
 * @request POST:/api/v1/member/refresh-token
 * @secure */
export function fetchRefreshToken(signal?: AbortSignal): Promise<SchemaLoginTokenInfo> {
  return fetchApi({ url: '/member/refresh-token', method: 'POST', signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name FetchMemberRefusePermission
 * @summary 拒絕權限
 * @request GET:/api/v1/member/refuse_permission
 * @secure */
export function fetchMemberRefusePermission(signal?: AbortSignal): Promise<SchemaStatusResult> {
  return fetchApi({ url: '/member/refuse_permission', method: 'GET', signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name FetchRegister
 * @summary 會員註冊
 * @request POST:/api/v1/member/register
 * @secure */
export function fetchRegister(request: SchemaMemberRegisterParam, signal?: AbortSignal): Promise<SchemaStatusResult> {
  return fetchApi({ url: '/member/register', method: 'POST', data: request, signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name FetchMemberSpeed
 * @summary 速度測試
 * @request GET:/api/v1/member/speed */
export function fetchMemberSpeed(signal?: AbortSignal): Promise<SchemaStatusResult> {
  return fetchApi({ url: '/member/speed', method: 'GET', signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name V1MemberTempAccessTokenList
 * @summary 生成臨時訪問令牌
 * @request GET:/api/v1/member/temp-access-token
 * @secure */
export function v1MemberTempAccessTokenList(signal?: AbortSignal): Promise<SchemaTempTokenInfo> {
  return fetchApi({ url: '/member/temp-access-token', method: 'GET', signal })
}
/**
 * No description *
 * @tags _Member, Business
 * @name V1MemberAnnounceList
 * @summary 會員查詢用戶彈窗列表
 * @request GET:/api/v1/member_announce
 * @secure */
export function v1MemberAnnounceList(
  query?: {
    /** 裝置類型(ios,android,cookie) */
    device_type?: string
    /** 當前頁碼 */
    current?: number
    /** 每頁數量 */
    pageSize?: number
  },
  signal?: AbortSignal
): Promise<SchemaMemberAnnounceShowQueryResult> {
  return fetchApi({ url: '/member_announce', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name FetchAddComicCollectList
 * @summary 添加漫畫收藏
 * @request POST:/api/v1/member_comic/favorite
 * @secure */
export function fetchAddComicCollectList(
  request: SchemaMemberComicFavoriteRelCreateParam,
  signal?: AbortSignal
): Promise<SchemaIDResult> {
  return fetchApi({ url: '/member_comic/favorite', method: 'POST', data: request, signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name FetchRemoveComicCollectList
 * @summary 刪除漫畫收藏
 * @request DELETE:/api/v1/member_comic/favorite/{comic_id}
 * @secure */
export function fetchRemoveComicCollectList(comicId: number, signal?: AbortSignal): Promise<SchemaStatusResult> {
  return fetchApi({ url: `/member_comic/favorite/${comicId}`, method: 'DELETE', signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name V1MemberGameCreate
 * @summary 創建遊戲URL
 * @request POST:/api/v1/member_game
 * @secure */
export function v1MemberGameCreate(
  request: SchemaMemberGameCreateUrlParam,
  signal?: AbortSignal
): Promise<SchemaStatusResult> {
  return fetchApi({ url: '/member_game', method: 'POST', data: request, signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name V1MemberGameClickCreate
 * @summary 記錄遊戲點擊統計
 * @request POST:/api/v1/member_game/click
 * @secure */
export function v1MemberGameClickCreate(signal?: AbortSignal): Promise<SchemaStatusResult> {
  return fetchApi({ url: '/member_game/click', method: 'POST', signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name FetchAddNovelCollectList
 * @summary 添加小說收藏
 * @request POST:/api/v1/member_novel/favorite
 * @secure */
export function fetchAddNovelCollectList(
  request: SchemaMemberNovelFavoriteRelCreateParam,
  signal?: AbortSignal
): Promise<SchemaIDResult> {
  return fetchApi({ url: '/member_novel/favorite', method: 'POST', data: request, signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name FetchRemoveNovelCollectList
 * @summary 刪除小說收藏
 * @request DELETE:/api/v1/member_novel/favorite/{novel_id}
 * @secure */
export function fetchRemoveNovelCollectList(novelId: number, signal?: AbortSignal): Promise<SchemaStatusResult> {
  return fetchApi({ url: `/member_novel/favorite/${novelId}`, method: 'DELETE', signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name FetchPurchaseProduct
 * @summary 建立會員訂單
 * @request POST:/api/v1/member_order
 * @secure */
export function fetchPurchaseProduct(
  request: SchemaMemberOrderCreateParam,
  signal?: AbortSignal
): Promise<SchemaMemberOrderResult> {
  return fetchApi({ url: '/member_order', method: 'POST', data: request, signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name FetchBuyVideo
 * @summary 會員購買影片
 * @request POST:/api/v1/member_video/buy_video
 * @secure */
export function fetchBuyVideo(request: SchemaMemberBuyVideoParam, signal?: AbortSignal): Promise<SchemaIDResult> {
  return fetchApi({ url: '/member_video/buy_video', method: 'POST', data: request, signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name FetchAddCollectList
 * @summary 會員添加影片收藏
 * @request POST:/api/v1/member_video/favorite
 * @secure */
export function fetchAddCollectList(
  request: SchemaMemberFavoriteRelCreateParam,
  signal?: AbortSignal
): Promise<SchemaIDResult> {
  return fetchApi({ url: '/member_video/favorite', method: 'POST', data: request, signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name FetchRemoveCollectList
 * @summary 會員刪除影片收藏
 * @request DELETE:/api/v1/member_video/favorite/{video_id}
 * @secure */
export function fetchRemoveCollectList(videoId: number, signal?: AbortSignal): Promise<SchemaStatusResult> {
  return fetchApi({ url: `/member_video/favorite/${videoId}`, method: 'DELETE', signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name FetchAddLikeList
 * @summary 會員點讚影片
 * @request POST:/api/v1/member_video/like
 * @secure */
export function fetchAddLikeList(
  request: SchemaMemberLikeRelCreateParam,
  signal?: AbortSignal
): Promise<SchemaIDResult> {
  return fetchApi({ url: '/member_video/like', method: 'POST', data: request, signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name FetchRemoveLikeList
 * @summary 會員取消點讚影片
 * @request DELETE:/api/v1/member_video/like/{video_id}
 * @secure */
export function fetchRemoveLikeList(videoId: number, signal?: AbortSignal): Promise<SchemaStatusResult> {
  return fetchApi({ url: `/member_video/like/${videoId}`, method: 'DELETE', signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name FetchCountViewVideo
 * @summary 記錄影片觀看次數
 * @request POST:/api/v1/member_video/watch_video
 * @secure */
export function fetchCountViewVideo(request: SchemaVideoViewParam, signal?: AbortSignal): Promise<SchemaStatusResult> {
  return fetchApi({ url: '/member_video/watch_video', method: 'POST', data: request, signal })
}
/**
 * No description *
 * @tags _Member, Novel
 * @name FetchNovelListBase
 * @summary 會員查詢小說列表
 * @request GET:/api/v1/novel
 * @secure */
export function fetchNovelListBase(
  query?: {
    /** 頁碼 */
    current?: number
    /** 每頁數量 */
    pageSize?: number
    /** 標題 */
    title?: string
    /** 小說ID */
    id?: number
    /** 小說編號 */
    novel_code?: string
    /** 作者 */
    author?: string
    /** 連載狀態(1:連載 2:完結) */
    serial?: number
    /** 標籤IDs(逗號分隔) */
    tag_ids?: string
    /** 分類IDs(逗號分隔) */
    category_ids?: string
    /** 地區IDs(逗號分隔) */
    region_ids?: string
    /** 付費類型(1:免費 2:金幣 3:VIP) */
    payment_type?: number
    /** 收藏歷史(1:是 2:否) */
    favorite_history?: number
    /** 觀看歷史(1:是 2:否) */
    view_history?: number
    /** 購買歷史(1:是 2:否) */
    buy_history?: number
    /** 來源站 */
    source?: string
    /** 標籤數量 */
    tag_num?: number
    /** 已貼標(1:是 2:否) */
    tagged?: number
    /** 上架時間起(ex:2022-03-21 23:50:27) */
    on_shelf_at_begin?: string
    /** 上架時間迄(ex:2022-03-21 23:50:27) */
    on_shelf_at_end?: string
    /** 排序欄位(created_at,updated_at,hot,on_shelf_at,view_count,-view_count,random,vip_first) */
    sortby?: string
    /** 查詢僅回總數(1:是 2:否) */
    only_count?: number
  },
  signal?: AbortSignal
): Promise<SchemaNovelShowQueryResult> {
  return fetchApi({ url: '/novel', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, Novel
 * @name FetchNovelChaptersBase
 * @summary 會員查詢小說章節列表
 * @request GET:/api/v1/novel/chapter
 * @secure */
export function fetchNovelChaptersBase(
  query?: {
    /**
     * 章節ID
     * @format int64
     */
    id?: number
    /**
     * 小說ID
     * @format int64
     */
    novel_id?: number
    /** 小說名稱 */
    novel_title?: string
    /** 章節名稱 */
    title?: string
    /** 同步OSS狀態(1:是 2:否) */
    is_sync_oss?: number
    /** 當前頁碼 */
    current?: number
    /** 每頁數量 */
    pageSize?: number
    /** 查詢僅回總數(1:是 2:否) */
    only_count?: number
  },
  signal?: AbortSignal
): Promise<SchemaNovelChapterShowQueryResult> {
  return fetchApi({ url: '/novel/chapter', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, Novel
 * @name FetchNovelChapterKey
 * @summary 取得章節Key
 * @request POST:/api/v1/novel/chapter/key/{id}
 * @secure */
export function fetchNovelChapterKey(id: number, signal?: AbortSignal): Promise<SchemaNovelKeyResult> {
  return fetchApi({ url: `/novel/chapter/key/${id}`, method: 'POST', signal })
}
/**
 * No description *
 * @tags _Member, Novel
 * @name FetchNovelViewChapter
 * @summary 記錄章節觀看數
 * @request POST:/api/v1/novel/chapter/view
 * @secure */
export function fetchNovelViewChapter(
  request: SchemaChapterViewParam,
  signal?: AbortSignal
): Promise<SchemaStatusResult> {
  return fetchApi({ url: '/novel/chapter/view', method: 'POST', data: request, signal })
}
/**
 * No description *
 * @tags _Member, Oholo
 * @name PostAdLog
 * @summary 創建Oholo日誌
 * @request POST:/api/v1/oholo/log
 * @secure */
export function postAdLog(request: SchemaOholoLogCreateParam, signal?: AbortSignal): Promise<SchemaOholoLog> {
  return fetchApi({ url: '/oholo/log', method: 'POST', data: request, signal })
}
/**
 * No description *
 * @tags _Member, Oholo
 * @name FetchAdListV1
 * @summary 查詢Oholo素材列表(會員端)
 * @request GET:/api/v1/oholo/oholo_material
 * @secure */
export function fetchAdListV1(
  query?: {
    /** 略過的筆數 */
    base_offset?: number
    current?: number
    /** 過期狀態(1:未到期 2:到期) */
    expire_status?: number
    /** 內部跳轉類型 (1: NAV ID(default) 2:遊戲ID 3:片商ID 4:演員ID, 5:片商列表, 6:演員列表, 7:開通VIP)) */
    internal_type?: number
    /** 是否所有頻道(1:自動全選 2:人工設定) ps: only for 16.金剛區廣告 */
    is_all_tab?: number
    /** 素材Type (1:內部 2:外部) */
    link_type?: number
    /** 素材名稱 */
    name?: string
    /** 金主ID */
    oholoer_id?: number
    /** 金主名稱 */
    oholoer_name?: string
    /** 金主狀態 */
    oholoer_status?: number
    /** 查詢僅回總數 (1:是 2:否) */
    only_count?: number
    /** @max 3000 */
    pageSize?: number
    /** 版位ID */
    site_id?: number
    /** 版位類型(1. 启动页 2. 频道轮播 3. 橱窗下方 4. 橱窗更多 5. 橱窗中 6. 播放页面 7. 个人中心 8. 公告弹窗 9. 应用轮播 10. 应用图标5 11. 发现 12. 应用图标2 13. 应用图标3  14. 短视频广告位  15. 动态频道广告位 16.金剛區廣告) */
    site_type?: number
    /** 版位類型str ,串接 */
    site_types?: string
    /** 開始狀態(1:開始 2:未開始) */
    start_status?: number
    /** 状态(1:启用 2:停用) 會員端永遠只能查啟用 無須帶此參數 */
    status?: number
  },
  signal?: AbortSignal
): Promise<SchemaOholoMaterialShowQueryResult> {
  return fetchApi({ url: '/oholo/oholo_material', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, Oholo
 * @name FetchAdListBase
 * @summary 查詢Oholo素材列表V2(會員端)
 * @request GET:/api/v1/oholo/oholo_material/v2
 * @secure */
export function fetchAdListBase(
  query?: {
    /** 略過的筆數 */
    base_offset?: number
    current?: number
    /** 過期狀態(1:未到期 2:到期) */
    expire_status?: number
    /** 內部跳轉類型 (1: NAV ID(default) 2:遊戲ID 3:片商ID 4:演員ID, 5:片商列表, 6:演員列表, 7:開通VIP)) */
    internal_type?: number
    /** 是否所有頻道(1:自動全選 2:人工設定) ps: only for 16.金剛區廣告 */
    is_all_tab?: number
    /** 素材Type (1:內部 2:外部) */
    link_type?: number
    /** 素材名稱 */
    name?: string
    /** 金主ID */
    oholoer_id?: number
    /** 金主名稱 */
    oholoer_name?: string
    /** 金主狀態 */
    oholoer_status?: number
    /** 查詢僅回總數 (1:是 2:否) */
    only_count?: number
    /** @max 3000 */
    pageSize?: number
    /** 版位ID */
    site_id?: number
    /** 版位類型(1. 启动页 2. 频道轮播 3. 橱窗下方 4. 橱窗更多 5. 橱窗中 6. 播放页面 7. 个人中心 8. 公告弹窗 9. 应用轮播 10. 应用图标5 11. 发现 12. 应用图标2 13. 应用图标3  14. 短视频广告位  15. 动态频道广告位 16.金剛區廣告) */
    site_type?: number
    /** 版位類型str ,串接 */
    site_types?: string
    /** 開始狀態(1:開始 2:未開始) */
    start_status?: number
    /** 状态(1:启用 2:停用) 會員端永遠只能查啟用 無須帶此參數 */
    status?: number
  },
  signal?: AbortSignal
): Promise<SchemaOholoMaterialShowQueryResult> {
  return fetchApi({ url: '/oholo/oholo_material/v2', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, Product
 * @name FetchProductListBase
 * @summary 會員查詢商品列表
 * @request GET:/api/v1/product
 * @secure */
export function fetchProductListBase(
  query?: {
    /** 商品名稱 */
    name?: string
    /** 商品類型(1:金幣 2:VIP) */
    product_type?: number
    /** 狀態(1:啟用 2:停用) */
    status?: number
    /** 是否返傭(1:是 2:否) */
    rebate?: number
    /** 當前頁碼 */
    current?: number
    /** 每頁數量 */
    pageSize?: number
    /** 查詢僅回總數(1:是 2:否) */
    only_count?: number
  },
  signal?: AbortSignal
): Promise<SchemaProductShowQueryResult> {
  return fetchApi({ url: '/product', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, Product
 * @name FetchProductVideoList
 * @summary 會員查詢商品影片列表
 * @request GET:/api/v1/product/product_video
 * @secure */
export function fetchProductVideoList(
  query?: {
    /** 商品名稱 */
    name?: string
    /** 狀態(1:啟用 2:停用) */
    status?: number
    /** 當前頁碼 */
    current?: number
    /** 每頁數量 */
    pageSize?: number
    /** 查詢僅回總數(1:是 2:否) */
    only_count?: number
  },
  signal?: AbortSignal
): Promise<SchemaProductVideoShowQueryResult> {
  return fetchApi({ url: '/product/product_video', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, Product
 * @name V1ProductSubproductList
 * @summary 會員查詢子商品列表
 * @request GET:/api/v1/product/subproduct
 * @secure */
export function v1ProductSubproductList(
  query?: {
    /** 子商品名稱 */
    name?: string
    /** 當前頁碼 */
    current?: number
    /** 每頁數量 */
    pageSize?: number
  },
  signal?: AbortSignal
): Promise<SchemaSubproductShowQueryResult> {
  return fetchApi({ url: '/product/subproduct', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, Member
 * @name PostLandingStatistics
 * @summary 會員落地頁統計
 * @request POST:/api/v1/statistics/landing */
export function postLandingStatistics(
  request: SchemaMemberLandingParam,
  signal?: AbortSignal
): Promise<SchemaStatusResult> {
  return fetchApi({ url: '/statistics/landing', method: 'POST', data: request, signal })
}
/**
 * No description *
 * @tags _Member, Agent
 * @name GetLandingDomainsBase
 * @summary 會員查詢推廣域名列表
 * @request GET:/api/v1/statistics/landing_domain
 * @secure */
export function getLandingDomainsBase(
  query?: {
    /** 代理帳號(精準查詢；帶此參數時 domain_name 會接上 ?c={邀請碼}) */
    user_name_eq?: string
    /** 當前頁碼 */
    current?: number
    /** 每頁數量 */
    pageSize?: number
    /** 查詢僅回總數(1:是 2:否) */
    only_count?: number
  },
  signal?: AbortSignal
): Promise<SchemaPromoteDomainShowQueryResult> {
  return fetchApi({ url: '/statistics/landing_domain', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, SystemConfig
 * @name FetchSystemCdn
 * @summary 查詢CDN配置列表
 * @request GET:/api/v1/system/cdn
 * @secure */
export function fetchSystemCdn(
  query?: {
    /** 當前頁碼 */
    current?: number
    /** 每頁數量 */
    pageSize?: number
    /** 查詢僅回總數(1:是 2:否) */
    only_count?: number
  },
  signal?: AbortSignal
): Promise<SchemaSystemConfigShowQueryResult> {
  return fetchApi({ url: '/system/cdn', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, System
 * @name FetchAvailableOrigin
 * @summary 會員獲取域名配置
 * @request GET:/api/v1/system/domain
 * @secure */
export function fetchAvailableOrigin(signal?: AbortSignal): Promise<SchemaDomainShow> {
  return fetchApi({ url: '/system/domain', method: 'GET', signal })
}
/**
 * No description *
 * @tags _Member, SystemConfig
 * @name V1SystemKeepaliveList
 * @summary 會員測試連接保持
 * @request GET:/api/v1/system/keepalive */
export function v1SystemKeepaliveList(signal?: AbortSignal): Promise<void> {
  return fetchApi({ url: '/system/keepalive', method: 'GET', signal })
}
/**
 * No description *
 * @tags _Member, SystemConfig
 * @name FetchStation
 * @summary 查詢站點信息
 * @request GET:/api/v1/system/station
 * @secure */
export function fetchStation(signal?: AbortSignal): Promise<SchemaStationInfoResult> {
  return fetchApi({ url: '/system/station', method: 'GET', signal })
}
/**
 * No description *
 * @tags _Member, Transfer
 * @name PostTransferWallet
 * @summary 會員創建轉帳
 * @request POST:/api/v1/transfer/wallet
 * @secure */
export function postTransferWallet(
  request: SchemaTranserWalletBaseParam,
  signal?: AbortSignal
): Promise<SchemaStatusResult> {
  return fetchApi({ url: '/transfer/wallet', method: 'POST', data: request, signal })
}
/**
 * No description *
 * @tags _Member, Video
 * @name FetchVideoListBase
 * @summary 會員查詢視頻列表
 * @request GET:/api/v1/video
 * @secure */
export function fetchVideoListBase(
  query?: {
    /** 頁碼 */
    current?: number
    /** 每頁數量 */
    pageSize?: number
    /** 視頻ID */
    id?: number
    /** 番號 */
    video_code?: string
    /** 標題 */
    title?: string
    /** 關鍵字 */
    keyword?: string
    /** 分類IDs(逗號分隔, ex: 1,2,3) */
    category_ids?: string
    /** 標籤IDs(逗號分隔) */
    tag_ids?: string
    /** 話題IDs(逗號分隔) */
    topic_ids?: string
    /** 演員IDs(逗號分隔) */
    actor_ids?: string
    /** 片商ID */
    producer_id?: number
    /** 片商IDs(逗號分隔) */
    producer_ids?: string
    /** 地區ID */
    region_id?: number
    /** 地區IDs(逗號分隔) */
    region_ids?: string
    /** 付費類型(1:免費 2:金幣 3:VIP) */
    payment_type?: number
    /** 排序欄位(view_count,-view_count,created_at,on_shelf_at,hot,complex,7_days_hot,14_days_hot,30_days_hot,days_hot,month_hot) */
    sortby?: string
    /** 自訂熱門天數結束(搭配days_hot, 1-30, 代表幾天前的遠端) */
    hot_days?: number
    /** 自訂熱門天數起始(搭配days_hot, 0=今天, 代表幾天前的近端) */
    hot_days_start?: number
    /** 自訂熱門月份(搭配month_hot, 格式YYYY-MM, 多月份逗號分隔最多12個瀏覽數加總, ex:2026-06,2026-07) */
    hot_month?: string
    /** 自訂熱門年份(搭配year_hot, 格式YYYY, ex:2026) */
    hot_year?: string
    /** 推薦類型(1:女優 2:廠商 99:全選) */
    recommend?: number
    /** 特殊搜尋(1:排行榜) */
    special_search?: number
    /** 觀看歷史(1:是 2:否) */
    watch_history?: number
    /** 購買歷史(1:是 2:否) */
    buy_history?: number
    /** 收藏歷史(1:是 2:否) */
    favorite_history?: number
    /** 喜歡歷史(1:是 2:否) */
    like_history?: number
    /** 最熱影片(1:是 2:否) */
    hot_video?: number
    /** 詳細查詢-單部ID查詢用(1:是 2:否) */
    detail?: number
    /** 來源站 */
    source?: string
    /** 挑選(1:是 2:否) */
    picked?: number
    /** 是否顯示番號(1:是 2:否) */
    show_video_code?: number
    /** 標籤數量 */
    tag_num?: number
    /** 貼標狀態(0:全部 1:已貼標 2:未貼標) */
    tag_status?: number
    /** UP主狀態(0:全部 1:啟用 2:停用) */
    uploader_status?: number
    /** 是否指定查番號(1:使用 2:不使用) */
    is_specify_video_code?: number
    /** 同步OSS狀態(1:success 2:no sync 3:failed 4:going) */
    is_sync_oss?: number
    /** 上架時間起(ex:2022-03-21 23:50:27) */
    on_shelf_at_begin?: string
    /** 上架時間迄 */
    on_shelf_at_end?: string
    /** 建立時間起(ex:2022-03-21 23:50:27) */
    created_at_begin?: string
    /** 建立時間迄 */
    created_at_end?: string
    /** 查詢僅回總數(1:是 2:否) */
    only_count?: number
  },
  signal?: AbortSignal
): Promise<SchemaVideoShowQueryResult> {
  return fetchApi({ url: '/video', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, Actor
 * @name FetchActorListBase
 * @summary 會員查詢演員列表
 * @request GET:/api/v1/video/actor
 * @secure */
export function fetchActorListBase(
  query?: {
    /** 演員IDs(逗號分隔) */
    ids?: string
    /** 演員名稱 */
    name?: string
    /** 演員原名 */
    orig_name?: string
    /** 性別(1:男 2:女) */
    gender?: number
    /** 狀態(1:啟用 2:停用) */
    status?: number
    /** 區域ID */
    region_id?: number
    /** 推薦(1:是 2:否) */
    recommend?: number
    /** 發現頁(1:啟用 2:停用) */
    discover_page?: number
    /** 排序方式(recommend,-recommend,created_at,-created_at) */
    sortby?: string
    /** 頁碼 */
    current?: number
    /** 每頁數量 */
    pageSize?: number
    /** 查詢僅回總數(1:是 2:否) */
    only_count?: number
  },
  signal?: AbortSignal
): Promise<SchemaActorShowQueryResult> {
  return fetchApi({ url: '/video/actor', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, Actor
 * @name FetchActorNameList
 * @summary 會員查詢演員名稱列表
 * @request GET:/api/v1/video/actor/name
 * @secure */
export function fetchActorNameList(
  query?: {
    /** 演員名稱 */
    name?: string
    /** 狀態(1:啟用 2:停用) */
    status?: number
    /** 頁碼 */
    current?: number
    /** 每頁數量 */
    pageSize?: number
  },
  signal?: AbortSignal
): Promise<SchemaActorNameShowQueryResult> {
  return fetchApi({ url: '/video/actor/name', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, Video
 * @name V1VideoIosKeyDetail
 * @summary iOS視頻密鑰獲取
 * @request GET:/api/v1/video/ios/key/{id} */
export function v1VideoIosKeyDetail(
  id: number,
  query: {
    /** 認證令牌 */
    value: string
  },
  signal?: AbortSignal
): Promise<void> {
  return fetchApi({ url: `/video/ios/key/${id}`, method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, Video
 * @name FetchVideoM3U8
 * @summary iOS視頻M3U8獲取
 * @request GET:/api/v1/video/ios/m3u8/{id} */
export function fetchVideoM3U8(
  id: number,
  query: {
    /** 認證令牌 */
    value: string
  },
  signal?: AbortSignal
): Promise<void> {
  return fetchApi({ url: `/video/ios/m3u8/${id}`, method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, Video
 * @name FetchVideoKey
 * @summary 會員獲取視頻密鑰
 * @request GET:/api/v1/video/key/{id}
 * @secure */
export function fetchVideoKey(id: number, signal?: AbortSignal): Promise<void> {
  return fetchApi({ url: `/video/key/${id}`, method: 'GET', signal })
}
/**
 * No description *
 * @tags _Member, Video
 * @name V1VideoKey265List
 * @summary 取得265影片Key
 * @request GET:/api/v1/video/key265
 * @secure */
export function v1VideoKey265List(signal?: AbortSignal): Promise<void> {
  return fetchApi({ url: '/video/key265', method: 'GET', signal })
}
/**
 * No description *
 * @tags _Member, Video
 * @name FetchProducerListBase
 * @summary 會員查詢片商列表
 * @request GET:/api/v1/video/producer
 * @secure */
export function fetchProducerListBase(
  query?: {
    /** 片商名稱 */
    name?: string
    /** 狀態(1:啟用 2:停用) */
    status?: number
    /** 推薦(1:啟用 2:停用) */
    recommend?: number
    /** 片商類型(1:無 2:國產傳媒 3:AV廠商 4:UP原創 5:剪輯達人) */
    producer_type?: number
    /** 排序方式(name,-name) */
    sortby?: string
    /** 頁碼 */
    current?: number
    /** 每頁數量 */
    pageSize?: number
    /** 查詢僅回總數(1:是 2:否) */
    only_count?: number
  },
  signal?: AbortSignal
): Promise<SchemaProducerShowQueryResult> {
  return fetchApi({ url: '/video/producer', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, Video
 * @name FetchProducerNameList
 * @summary 會員查詢片商名稱列表
 * @request GET:/api/v1/video/producer/name
 * @secure */
export function fetchProducerNameList(
  query?: {
    /** 片商名稱 */
    name?: string
    /** 狀態(1:啟用 2:停用) */
    status?: number
    /** 頁碼 */
    current?: number
    /** 每頁數量 */
    pageSize?: number
  },
  signal?: AbortSignal
): Promise<SchemaProducerNameShowQueryResult> {
  return fetchApi({ url: '/video/producer/name', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, VideoRegion
 * @name FetchRegionListBase
 * @summary 會員查詢視頻地區列表
 * @request GET:/api/v1/video/region
 * @secure */
export function fetchRegionListBase(
  query?: {
    /** 地區名稱 */
    name?: string
    /** 地區種類(1:長視頻 2:短視頻 3:漫畫 4:小說) */
    kind?: number
    /** 當前頁碼 */
    current?: number
    /** 每頁數量 */
    pageSize?: number
  },
  signal?: AbortSignal
): Promise<SchemaVideoRegionShowQueryResult> {
  return fetchApi({ url: '/video/region', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, Video
 * @name FetchVideoShare
 * @summary 取得影片分享資訊
 * @request GET:/api/v1/video/share/{id}
 * @secure */
export function fetchVideoShare(
  id: number,
  query?: {
    /** CloudFront 資源路徑(完整 URL,需 URL-encode),有帶才回傳 cloudfront 簽章資訊 */
    resource?: string
  },
  signal?: AbortSignal
): Promise<SchemaVideoShareInfoResult> {
  return fetchApi({ url: `/video/share/${id}`, method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, Video
 * @name FetchShortListBase
 * @summary 會員查詢短視頻列表
 * @request GET:/api/v1/video/short
 * @secure */
export function fetchShortListBase(
  query?: {
    /** 頁碼 */
    current?: number
    /** 每頁數量 */
    pageSize?: number
    /** 視頻ID */
    id?: number
    /** 番號 */
    video_code?: string
    /** 標題 */
    title?: string
    /** 分類IDs(逗號分隔) */
    category_ids?: string
    /** 話題IDs(逗號分隔) */
    topic_ids?: string
    /** 地區ID */
    region_id?: number
    /** 地區IDs(逗號分隔) */
    region_ids?: string
    /** UP主ID */
    uploader_id?: number
    /** 付費類型(1:免費 2:金幣 3:VIP) */
    payment_type?: number
    /** 排序欄位(view_count,-view_count,created_at,on_shelf_at,hot,vip_first,7_days_hot,14_days_hot,30_days_hot,days_hot,month_hot) */
    sortby?: string
    /** 自訂熱門天數結束(搭配days_hot, 1-30, 代表幾天前的遠端) */
    hot_days?: number
    /** 自訂熱門天數起始(搭配days_hot, 0=今天, 代表幾天前的近端) */
    hot_days_start?: number
    /** 自訂熱門月份(搭配month_hot, 格式YYYY-MM, 多月份逗號分隔最多12個瀏覽數加總, ex:2026-06,2026-07) */
    hot_month?: string
    /** 自訂熱門年份(搭配year_hot, 格式YYYY, ex:2026) */
    hot_year?: string
    /** 特殊搜尋(1:排行榜) */
    special_search?: number
    /** 觀看歷史(1:是 2:否) */
    watch_history?: number
    /** 購買歷史(1:是 2:否) */
    buy_history?: number
    /** 收藏歷史(1:是 2:否) */
    favorite_history?: number
    /** 喜歡歷史(1:是 2:否) */
    like_history?: number
    /** 詳細查詢-單部ID查詢用(1:是 2:否) */
    detail?: number
    /** 來源站 */
    source?: string
    /** 是否顯示番號(1:是 2:否) */
    show_video_code?: number
    /** 貼標狀態(0:全部 1:已貼標 2:未貼標) */
    tag_status?: number
    /** 話題數量 */
    topic_num?: number
    /** UP主狀態(0:全部 1:啟用 2:停用) */
    uploader_status?: number
    /** 上架時間起(ex:2022-03-21 23:50:27) */
    on_shelf_at_begin?: string
    /** 上架時間迄 */
    on_shelf_at_end?: string
    /** 建立時間起(ex:2022-03-21 23:50:27) */
    created_at_begin?: string
    /** 建立時間迄 */
    created_at_end?: string
    /** 查詢僅回總數(1:是 2:否) */
    only_count?: number
  },
  signal?: AbortSignal
): Promise<SchemaShortVideoShowQueryResult> {
  return fetchApi({ url: '/video/short', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, Video
 * @name V1VideoShortWaterfallList
 * @summary 會員瀑布流短影片
 * @request GET:/api/v1/video/short/waterfall
 * @secure */
export function v1VideoShortWaterfallList(
  query?: {
    /** 每頁數量(最大50) */
    pageSize?: number
  },
  signal?: AbortSignal
): Promise<SchemaShortVideoWaterfallResult> {
  return fetchApi({ url: '/video/short/waterfall', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, Tag
 * @name FetchVideoTagListBase
 * @summary 查詢標籤列表(會員端)
 * @request GET:/api/v1/video/tag
 * @secure */
export function fetchVideoTagListBase(
  query?: {
    /** 標籤ID */
    id?: number
    /** 標籤名稱 */
    name?: string
    /** 標籤等級(1或2) */
    level?: number
    /** 上級標籤ID */
    parent_id?: number
    /** 是否推薦(1:是 2:否) */
    promote?: number
    /** 標籤分類(1:視頻 2:漫畫 3:小說) */
    type?: number
    /** 操作人 */
    editor?: string
    /** 排序 */
    seqno?: number
    /** 後台來源(1:基礎管理 2:視頻管理) */
    source_type?: number
    /** 排序方式(seqno,-seqno,video_tag_count,-video_tag_count) */
    sortby?: string
    /** 頁碼 */
    current?: number
    /** 每頁數量 */
    pageSize?: number
    /** 查詢僅回總數(1:是 2:否) */
    only_count?: number
  },
  signal?: AbortSignal
): Promise<SchemaTagShowQueryResult> {
  return fetchApi({ url: '/video/tag', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, Topic
 * @name FetchVideoTopicListBase
 * @summary 查詢話題列表(會員端)
 * @request GET:/api/v1/video/topic
 * @secure */
export function fetchVideoTopicListBase(
  query?: {
    /** 話題ID */
    id?: number
    /** 話題名稱 */
    name?: string
    /** 是否推薦(1:是 2:否) */
    promote?: number
    /** 操作人 */
    editor?: string
    /** 排序 */
    seqno?: number
    /** 後台來源(1:基礎管理 2:視頻管理) */
    source_type?: number
    /** 排序方式(seqno,-seqno,topic_count,-topic_count) */
    sortby?: string
    /** 頁碼 */
    current?: number
    /** 每頁數量 */
    pageSize?: number
    /** 查詢僅回總數(1:是 2:否) */
    only_count?: number
  },
  signal?: AbortSignal
): Promise<SchemaTopicShowQueryResult> {
  return fetchApi({ url: '/video/topic', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, VideoUploader
 * @name FetchUploaderListBase
 * @summary 會員查詢上傳者列表
 * @request GET:/api/v1/video/uploader
 * @secure */
export function fetchUploaderListBase(
  query?: {
    /** 當前頁碼 */
    current?: number
    /** 每頁數量 */
    pageSize?: number
    /** 查詢僅回總數(1:是 2:否) */
    only_count?: number
  },
  signal?: AbortSignal
): Promise<SchemaVideoUploaderShowQueryResult> {
  return fetchApi({ url: '/video/uploader', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @tags _Member, VideoUploader
 * @name FetchUploaderNameList
 * @summary 會員查詢上傳者名稱列表
 * @request GET:/api/v1/video/uploader/name
 * @secure */
export function fetchUploaderNameList(
  query?: {
    /** 當前頁碼 */
    current?: number
    /** 每頁數量 */
    pageSize?: number
    /** 查詢僅回總數(1:是 2:否) */
    only_count?: number
  },
  signal?: AbortSignal
): Promise<SchemaVideoUploaderNameShowQueryResult> {
  return fetchApi({ url: '/video/uploader/name', method: 'GET', data: query, signal })
}
/**
 * No description *
 * @name PutCurrentPassword
 * @request PUT:/api/v1/pub/current/password */
export function putCurrentPassword(signal?: AbortSignal): Promise<any> {
  return fetchApi({ url: '/pub/current/password', method: 'PUT', signal })
}
